import { Util, Badge as Badge$1, Button as Button$1, Collapse as Collapse$1, NavbarBrand, Navbar, NavbarToggler, Jumbotron, Nav as Nav$1, FormGroup, Label, Input as Input$1, Card as Card$1 } from 'reactstrap';
export { Alert, Breadcrumb, BreadcrumbItem, ButtonDropdown, ButtonGroup, ButtonToolbar, CardBody, CardColumns, CardDeck, CardFooter, CardGroup, CardHeader, CardImg, CardImgOverlay, CardLink, CardSubtitle, CardText, CardTitle, Carousel, CarouselCaption, CarouselControl, CarouselIndicators, CarouselItem, Col, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Fade, Form, FormFeedback, FormGroup, FormText, InputGroup, InputGroupAddon, InputGroupButtonDropdown, InputGroupText, Jumbotron, Label, ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText, Media, Modal, ModalBody, ModalFooter, ModalHeader, NavItem, NavLink, Navbar, NavbarBrand, NavbarToggler, PaginationItem as PagerItem, PaginationLink as PagerLink, Popover, PopoverBody, PopoverHeader, PopperContent, PopperTargetHelper, Row, TabContent, TabPane, Table, Tooltip, UncontrolledAlert, UncontrolledButtonDropdown, UncontrolledCarousel, UncontrolledCollapse, UncontrolledDropdown, UncontrolledTooltip, Util } from 'reactstrap';
export { default as Scrollspy } from 'react-scrollspy';
import React__default, { Component, createElement, PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import { StickyProvider, Sticky } from 'react-stickup';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
};
var defaultProps = {
  tag: 'div'
};

function Accordion(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag"]);

  var classes = classnames('collapse-div', className);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;
var propTypes$1 = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  active: PropTypes.bool,
  onToggle: PropTypes.func
};
var defaultProps$1 = {
  tag: 'button'
};

function AccordionHeader(props) {
  var className = props.className,
      Tag = props.tag,
      active = props.active,
      onToggle = props.onToggle,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag", "active", "onToggle"]);

  var classes = classnames('collapse-header');
  var toggleClasses = classnames(className, {
    collapsed: active
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes
  }, /*#__PURE__*/React__default.createElement(Tag, _extends({
    "data-toggle": "collapse",
    "aria-expanded": active ? 'true' : 'false',
    className: toggleClasses,
    onClick: onToggle
  }, attributes)));
}

AccordionHeader.propTypes = propTypes$1;
AccordionHeader.defaultProps = defaultProps$1;

var _transitionStatusToCl;

var TransitionTimeouts = Util.TransitionTimeouts,
    TransitionPropTypeKeys = Util.TransitionPropTypeKeys,
    TransitionStatuses = Util.TransitionStatuses,
    pick = Util.pick,
    omit = Util.omit;

var propTypes$2 = _extends({}, Transition.propTypes, {
  // eslint-disable-line react/forbid-foreign-prop-types
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  active: PropTypes.bool,
  onToggle: PropTypes.func
});

var defaultProps$2 = _extends({}, Transition.defaultProps, {
  timeout: TransitionTimeouts.Collapse,
  tag: 'div'
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[TransitionStatuses.ENTERING] = 'collapsing', _transitionStatusToCl[TransitionStatuses.ENTERED] = 'collapse show', _transitionStatusToCl[TransitionStatuses.EXITING] = 'collapsing', _transitionStatusToCl[TransitionStatuses.EXITED] = 'collapse', _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var AccordionBody = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AccordionBody, _Component);

  function AccordionBody() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      height: null
    });

    _defineProperty(_assertThisInitialized(_this), "onEntering", function (node, isAppearing) {
      _this.setState({
        height: getHeight(node)
      });

      _this.props.onEntering(node, isAppearing);
    });

    _defineProperty(_assertThisInitialized(_this), "onEntered", function (node, isAppearing) {
      _this.setState({
        height: null
      });

      _this.props.onEntered(node, isAppearing);
    });

    _defineProperty(_assertThisInitialized(_this), "onExit", function (node) {
      _this.setState({
        height: getHeight(node)
      });

      _this.props.onExit(node);
    });

    _defineProperty(_assertThisInitialized(_this), "onExiting", function (node) {
      // getting this variable triggers a reflow
      var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars

      _this.setState({
        height: 0
      });

      _this.props.onExiting(node);
    });

    _defineProperty(_assertThisInitialized(_this), "onExited", function (node) {
      _this.setState({
        height: null
      });

      _this.props.onExited(node);
    });

    return _this;
  }

  var _proto = AccordionBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        Tag = _this$props.tag,
        active = _this$props.active,
        children = _this$props.children,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["className", "tag", "active", "children"]);

    var height = this.state.height;
    var transitionProps = pick(attributes, TransitionPropTypeKeys);
    var childProps = omit(attributes, TransitionPropTypeKeys);
    return /*#__PURE__*/React__default.createElement(Transition, _extends({}, transitionProps, {
      in: active,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), function (status) {
      var transitionClass = getTransitionClass(status);
      var classes = classnames(className, transitionClass);
      var style = height === null ? null : {
        height: height
      };
      return /*#__PURE__*/React__default.createElement(Tag, _extends({
        className: classes,
        style: _extends({}, childProps.style, style)
      }, childProps), /*#__PURE__*/React__default.createElement("div", {
        className: "collapse-body"
      }, children));
    });
  };

  return AccordionBody;
}(Component);

AccordionBody.propTypes = propTypes$2;
AccordionBody.defaultProps = defaultProps$2;
var propTypes$3 = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
};
var defaultProps$3 = {
  tag: 'div'
};

var AvatarContainer = function AvatarContainer(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag"]);

  var wrapperClasses = classnames('d-flex align-items-center justify-content-around flex-wrap flex-sm-nowrap', className);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: wrapperClasses
  }));
};

AvatarContainer.propTypes = propTypes$3;
AvatarContainer.defaultProps = defaultProps$3;
var propTypes$4 = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  wrapperClassName: PropTypes.string
};
var defaultProps$4 = {
  tag: 'ul'
};

var AvatarGroupContainer = function AvatarGroupContainer(props) {
  var className = props.className,
      Tag = props.tag,
      wrapperClassName = props.wrapperClassName,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag", "wrapperClassName"]);

  var wrapperClasses = classnames('avatar-group-stacked', wrapperClassName);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: wrapperClasses
  }));
};

AvatarGroupContainer.propTypes = propTypes$4;
AvatarGroupContainer.defaultProps = defaultProps$4;
var propTypes$5 = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
};
var defaultProps$5 = {
  tag: 'div'
};

var AvatarExtraText = function AvatarExtraText(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag"]);

  var wrapperClass = classnames('extra-text', className);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: wrapperClass
  }, attributes));
};

AvatarExtraText.propTypes = propTypes$5;
AvatarExtraText.defaultProps = defaultProps$5;
var propTypes$6 = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  href: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  color: PropTypes.string,
  size: PropTypes.string
};
var defaultProps$6 = {
  tag: 'div'
};

var AvatarIcon = function AvatarIcon(props) {
  var _classNames;

  var className = props.className,
      Tag = props.tag,
      size = props.size,
      href = props.href,
      color = props.color,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag", "size", "href", "color"]);

  var typeClass = classnames('avatar', (_classNames = {}, _classNames["size-" + size] = size, _classNames["avatar-" + color] = color, _classNames));

  if (href) {
    return /*#__PURE__*/React__default.createElement("a", _extends({
      href: href
    }, attributes, {
      className: typeClass
    }));
  }

  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: typeClass
  }));
};

AvatarIcon.propTypes = propTypes$6;
AvatarIcon.defaultProps = defaultProps$6;
var propTypes$7 = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  presence: PropTypes.string
};
var defaultProps$7 = {
  tag: 'div'
};

var AvatarPresence = function AvatarPresence(props) {
  var _classNames;

  var className = props.className,
      Tag = props.tag,
      presence = props.presence,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag", "presence"]);

  var typeClass = classnames('avatar-presence', (_classNames = {}, _classNames["" + presence] = presence, _classNames));
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: typeClass
  }));
};

AvatarPresence.propTypes = propTypes$7;
AvatarPresence.defaultProps = defaultProps$7;
var propTypes$8 = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  status: PropTypes.string
};
var defaultProps$8 = {
  tag: 'div'
};

var AvatarStatus = function AvatarStatus(props) {
  var _classNames;

  var className = props.className,
      Tag = props.tag,
      status = props.status,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag", "status"]);

  var typeClass = classnames('avatar-status', (_classNames = {}, _classNames["" + status] = status, _classNames));
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: typeClass
  }));
};

AvatarStatus.propTypes = propTypes$8;
AvatarStatus.defaultProps = defaultProps$8;
var propTypes$9 = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  extra: PropTypes.string
};
var defaultProps$9 = {
  tag: 'div'
};

var AvatarWrapper = function AvatarWrapper(props) {
  var _classNames;

  var className = props.className,
      Tag = props.tag,
      extra = props.extra,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag", "extra"]);

  var wrapperClass = classnames('avatar-wrapper', className, (_classNames = {}, _classNames["avatar-extra-" + extra] = extra, _classNames));
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: wrapperClass
  }));
};

AvatarWrapper.propTypes = propTypes$9;
AvatarWrapper.defaultProps = defaultProps$9;
var propTypes$a = {
  color: PropTypes.string,
  pill: PropTypes.bool,
  tag: PropTypes.string,
  children: PropTypes.node,
  cssModule: PropTypes.object,
  className: PropTypes.string
};
var defaultProps$a = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var children = props.children;
  return /*#__PURE__*/React__default.createElement(Badge$1, props, children);
};

Badge.propTypes = propTypes$a;
Badge.defaultProps = defaultProps$a;

var propTypes$b = _extends({}, Button$1.propTypes, {
  icon: PropTypes.bool
});

var defaultProps$b = _extends({}, Button$1.defaultProps, {
  icon: false
});

var Button = function Button(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["icon", "className"]);

  var classes = classnames(className, {
    'btn-icon': icon
  });
  return /*#__PURE__*/React__default.createElement(Button$1, _extends({
    className: classes
  }, attributes));
};

Button.propTypes = propTypes$b;
Button.defaultProps = defaultProps$b;

if (typeof window === 'undefined') {
  global.Element = typeof Element === 'undefined' ? function () {} : Element;
}

var propTypes$c = {
  className: PropTypes.string,
  scrollToRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })
};

var Forward = function Forward(_ref) {
  var className = _ref.className,
      scrollToRef = _ref.scrollToRef,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "scrollToRef"]);

  var classes = classnames(className, 'forward');
  return /*#__PURE__*/React__default.createElement("a", _extends({
    className: classes,
    onClick: function onClick() {
      return scrollToRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, attributes));
};

Forward.propTypes = propTypes$c;
var propTypes$d = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  highlight: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};
var defaultProps$c = {
  color: '',
  highlight: false,
  tag: 'div'
};

var Callout = function Callout(_ref) {
  var children = _ref.children,
      color = _ref.color,
      highlight = _ref.highlight,
      Tag = _ref.tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["children", "color", "highlight", "tag"]);

  var classes = classnames('callout', color, {
    'callout-highlight': highlight
  });
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, attributes), children);
};

Callout.propTypes = propTypes$d;
Callout.defaultProps = defaultProps$c;
var propTypes$e = {
  bigText: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};
var defaultProps$d = {
  bigText: false,
  tag: 'p'
};

var CalloutText = function CalloutText(_ref) {
  var bigText = _ref.bigText,
      children = _ref.children,
      className = _ref.className,
      Tag = _ref.tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["bigText", "children", "className", "tag"]);

  var classes = classnames(className, {
    'callout-big-text': bigText
  });
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, attributes), children);
};

CalloutText.propTypes = propTypes$e;
CalloutText.defaultProps = defaultProps$d;
var propTypes$f = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};
var defaultProps$e = {
  tag: 'div'
};

var CalloutTitle = function CalloutTitle(_ref) {
  var children = _ref.children,
      className = _ref.className,
      Tag = _ref.tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["children", "className", "tag"]);

  var classes = classnames(className, 'callout-title');
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, attributes), children);
};

CalloutTitle.propTypes = propTypes$f;
CalloutTitle.defaultProps = defaultProps$e;

var propTypes$g = _extends({}, Collapse$1.propTypes, {
  // eslint-disable-line react/forbid-foreign-prop-types

  /** Indica se il componente Collapse è usato all'interno di un componente Header */
  header: PropTypes.bool,

  /** Indica se il menu HeaderNav sia aperto o meno. Usato unicamente nel caso della HeaderNav, ovvero con navbar e header entrambi true */
  inOpen: PropTypes.bool,

  /** Funzione chiamata su click di overlay dell'HeaderNav aperto. Usato unicamente nel caso della HeaderNav, ovvero con navbar e header entrambi true */
  onOverlayClick: PropTypes.func
});

var Collapse = function Collapse(_ref) {
  var header = _ref.header,
      className = _ref.className,
      navbar = _ref.navbar,
      children = _ref.children,
      isOpen = _ref.isOpen,
      onOverlayClick = _ref.onOverlayClick,
      attributes = _objectWithoutPropertiesLoose(_ref, ["header", "className", "navbar", "children", "isOpen", "onOverlayClick"]);

  if (navbar && header) {
    var _classes = classnames(className, 'navbar-collapse', {
      expanded: isOpen
    });

    return /*#__PURE__*/React__default.createElement(Collapse$1, _extends({
      className: _classes,
      cssModule: {
        'navbar-collapse': 'navbar-collapsable'
      },
      navbar: navbar,
      style: {
        display: isOpen ? 'block' : 'none'
      }
    }, attributes), /*#__PURE__*/React__default.createElement("div", {
      className: "overlay",
      style: {
        display: isOpen ? 'block' : 'none'
      },
      onClick: onOverlayClick
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "close-div sr-only"
    }, /*#__PURE__*/React__default.createElement("button", {
      className: "btn close-menu",
      type: "button"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "it-close"
    }), "close")), children);
  }

  var classes = classnames(className, {
    'link-list-wrapper': header
  });
  return /*#__PURE__*/React__default.createElement(Collapse$1, _extends({
    className: classes,
    cssModule: {
      'navbar-collapse': 'navbar-collapsable'
    }
  }, attributes, {
    navbar: navbar,
    isOpen: isOpen
  }), children);
};

Collapse.propTypes = propTypes$g;
Collapse.defaultProps = Collapse$1.defaultProps;
/**
 * HeaderContext
 * {
 *  type: PropTypes.oneOf([SLIM, CENTER, NAVBAR]).isRequired
 * }
 */

var HeaderContext = /*#__PURE__*/React__default.createContext({});
var SLIM = 'slim';
var CENTER = 'center';
var NAVBAR = 'navbar';
var propTypes$h = {
  /** Classi addizionali per il componente Header */
  className: PropTypes.string,
  // cannot use variables above here or storybook writes the full import stacktrace

  /** Tipo di componente Header: può essere solamente uno di questi tre tipi */
  type: PropTypes.oneOf(['slim', 'center', 'navbar']).isRequired,

  /** Riduce la grandezza del componente Header. Funziona solamente con Header "center". */
  small: PropTypes.bool,

  /** Imposta il tema per il componente Header. Per gli Header di tipo "slim" o "center"
   *  il valore di default è "dark". Per l'Header di tipo "nav" il tema di default è "light"
   *  in mobile, mentre "dark" in versione desktop.
   */
  theme: PropTypes.oneOf(['', 'light', 'dark'])
};
var defaultProps$f = {
  small: false
};

var Header = function Header(_ref) {
  var _classNames;

  var className = _ref.className,
      small = _ref.small,
      theme = _ref.theme,
      type = _ref.type,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "small", "theme", "type"]); // use context here as theme


  var classes = classnames(className, (_classNames = {}, _classNames["it-header-" + type + "-wrapper"] = type, _classNames['it-small-header'] = type === CENTER && small, _classNames["theme-" + theme] = type !== NAVBAR && theme, _classNames['theme-dark-mobile'] = type === NAVBAR && theme === 'dark', _classNames['theme-light-desk'] = type === NAVBAR && theme === 'light', _classNames));
  return /*#__PURE__*/React__default.createElement(HeaderContext.Provider, {
    value: {
      type: type
    }
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, attributes)));
};

Header.propTypes = propTypes$h;
Header.defaultProps = defaultProps$f;
var propTypes$i = {
  /** Aggiunge un ombra per enfatizzare il componente rispetto alla pagina in cui è contenuto */
  shadow: PropTypes.bool,

  /** Aggiunge il comportamento "sticky" ai componenti Header contenuti */
  sticky: PropTypes.bool,

  /** Classi addizionali per il componente Headers */
  className: PropTypes.string
};
var defaultProps$g = {
  shadow: false,
  sticky: false
};

var Headers = function Headers(_ref) {
  var className = _ref.className,
      shadow = _ref.shadow,
      sticky = _ref.sticky,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "shadow", "sticky"]);

  var classes = classnames('it-header-wrapper', {
    'it-shadow': shadow,
    'it-header-sticky': sticky
  }, className);

  if (!sticky) {
    return /*#__PURE__*/React__default.createElement("div", _extends({
      className: classes
    }, attributes));
  }

  return /*#__PURE__*/React__default.createElement(StickyProvider, null, /*#__PURE__*/React__default.createElement(Sticky, {
    style: {
      position: 'sticky',
      zIndex: 2
    }
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, attributes))));
};

Headers.propTypes = propTypes$i;
Headers.defaultProps = defaultProps$g;

function SvgItArrowDownCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M15.6 13.2l.7.7-4.3 4.3-4.3-4.3.7-.7 3.1 3.1V7h1v9.2zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowDownTriangle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M9.2 12h5.6a1 1 0 01.7 1.7L12 17.3l-3.5-3.6a1 1 0 01.7-1.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowDown(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M17.9 13.2l-5.4 5.3V3h-1v15.5l-5.4-5.3-.7.7 6.6 6.5 6.6-6.5zM12 19z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowLeftCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M7.7 11.5H17v1H7.8l3 3.1-.7.7L5.8 12l4.3-4.3.7.7zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowLeftTriangle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 9.2v5.6a1 1 0 01-1.7.7L6.8 12l3.5-3.5a1 1 0 011.7.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M21 11.5H5.5l5.3-5.4-.7-.7L3.6 12l6.5 6.6.7-.7-5.3-5.4H21zM5 12z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowRightCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M13.9 7.7l4.3 4.3-4.3 4.3-.7-.7 3.1-3.1H7v-1h9.2l-3-3.1zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowRightTriangle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 14.8V9.2a1 1 0 011.7-.7l3.5 3.5-3.5 3.5a1 1 0 01-1.7-.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowRight(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M13.9 5.4l-.7.7 5.3 5.4H3v1h15.5l-5.3 5.4.7.7 6.6-6.6zM19 12z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowUpCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 5.8l4.3 4.3-.7.7-3.1-3.1V17h-1V7.8l-3.1 3-.7-.7zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowUpTriangle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M14.8 12H9.2a1 1 0 01-.7-1.7L12 6.8l3.5 3.5a1 1 0 01-.7 1.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItArrowUp(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M18.6 10.1L12 3.5l-6.6 6.6.7.7 5.4-5.3V21h1V5.5l5.4 5.3zM12 5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItBan(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM5.2 17.6C3.8 16 3.1 14 3.1 11.9s.7-4.1 2.1-5.7l12.7 12.7C14 22 8.3 21.4 5.2 17.6zm13.4.5L5.9 5.4c3.7-3.3 9.4-3 12.7.7 3.1 3.4 3.1 8.6 0 12z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItBehance(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M7.83 5.75a8 8 0 011.6.15 3.38 3.38 0 011.24.51c.345.233.62.554.8.93.202.456.298.952.28 1.45a2.68 2.68 0 01-.42 1.54 3.05 3.05 0 01-1.25 1 2.92 2.92 0 011.68 1.15c.393.59.59 1.29.56 2a3.39 3.39 0 01-.32 1.59 3.08 3.08 0 01-1 1.11 4.27 4.27 0 01-1.4.64A6 6 0 018 18H2V5.75h5.83zm-.35 5a2 2 0 001.19-.35c.328-.27.5-.687.46-1.11A1.47 1.47 0 009 8.54a1.16 1.16 0 00-.42-.43A1.8 1.8 0 008 7.9a3.26 3.26 0 00-.7-.06H4.74v2.87l2.74.04zm.15 5.22c.252.003.503-.02.75-.07a2 2 0 00.62-.3 1.39 1.39 0 00.44-.49 1.73 1.73 0 00.16-.8A1.64 1.64 0 009.09 13a2.33 2.33 0 00-1.41-.4H4.74v3.38l2.89-.01zm8.54-.08a2.18 2.18 0 001.58.54 2.24 2.24 0 001.25-.37 1.6 1.6 0 00.65-.79h2.15a4.06 4.06 0 01-1.58 2.29 4.64 4.64 0 01-2.58.69 5.23 5.23 0 01-1.9-.33 4 4 0 01-2.33-2.44 5.25 5.25 0 01-.32-1.89 5.12 5.12 0 01.33-1.86 4.14 4.14 0 01.93-1.49 4.48 4.48 0 011.44-1 4.59 4.59 0 011.85-.36 4.31 4.31 0 012 .44A4 4 0 0121 10.5c.37.505.636 1.08.78 1.69a6.18 6.18 0 01.17 2h-6.38a2.5 2.5 0 00.6 1.7zM19 11.22a1.83 1.83 0 00-1.38-.49 2 2 0 00-1 .2 1.8 1.8 0 00-.62.49 1.62 1.62 0 00-.33.62 2.87 2.87 0 00-.11.59h4a2.4 2.4 0 00-.56-1.41zm-3.93-4.65h4.98v1.21h-4.98V6.57z"
  }));
}

function SvgItBookmark(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M18 22.7l-6-6-6 6V2h12v20.7zm-6-7.4l5 5V3H7v17.3l5-5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItBox(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M21 2H3v4h1v16h16V6h1V2zm-2 19H5V6h14v15zm1-16H4V3h16v2z"
  }), /*#__PURE__*/createElement("path", {
    d: "M8 8h8v1H8z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItBurger(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M22 5v1H2V5zM2 12.5h20v-1H2zM2 19h20v-1H2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItCalendar(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M20.5 4H17V3h-1v1H8V3H7v1H3.5A1.5 1.5 0 002 5.5v13A1.5 1.5 0 003.5 20h17a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0020.5 4zm.5 14.5a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-13a.5.5 0 01.5-.5H7v1h1V5h8v1h1V5h3.5a.5.5 0 01.5.5zM4 8h16v1H4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItCamera(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M20.5 20h-17A1.5 1.5 0 012 18.5v-10A1.5 1.5 0 013.5 7h4.3l1.5-2.3a1.5 1.5 0 011.2-.7h3a1.5 1.5 0 011.2.7L16.2 7h4.3A1.5 1.5 0 0122 8.5v10a1.5 1.5 0 01-1.5 1.5zM3.5 8a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-10a.5.5 0 00-.5-.5h-4.8l-1.8-2.8-.4-.2h-3l-.4.2L8.3 8zM12 18a5 5 0 115-5 5 5 0 01-5 5zm0-9a4 4 0 104 4 4 4 0 00-4-4zM7 5H4v1h3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItCard(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M20.5 5h-17A1.5 1.5 0 002 6.5v11A1.5 1.5 0 003.5 19h17a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0020.5 5zM3 9h18v3H3zm18 8.5a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5V13h18zM3 8V6.5a.5.5 0 01.5-.5h17a.5.5 0 01.5.5V8zm5 7H4v-1h4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItChartLine(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M21 20v1H3V3h1v17z"
  }), /*#__PURE__*/createElement("path", {
    d: "M10.5 9.2l2.5 2.5 6-6v3.8h1V4h-5.5v1h3.8L13 10.3l-2.5-2.5-4.3 4.3.6.8z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItCheckCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M17.1 7.9l.7.7-7.8 7.6-4.7-4.6.7-.7 4 3.9zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M9.6 16.9L4 11.4l.8-.7 4.8 4.8 8.5-8.4.7.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItChevronLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M14.6 17.2L9 11.6 14.6 6l.8.7-4.9 4.9 4.9 4.9z"
  }));
}

function SvgItChevronRight(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M9.8 17.2l-.8-.7 4.9-4.9L9 6.7l.8-.7 5.6 5.6z"
  }));
}

function SvgItClip(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M11 22a2.9 2.9 0 01-3-3V6a4 4 0 018 0v10h-1V6a3 3 0 00-6 0v13a2 2 0 004 0V8a1 1 0 00-2 0v8h-1V8a2 2 0 014 0v11a2.9 2.9 0 01-3 3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItClock(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M11.5 5h1v7.5H7v-1h4.5zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItCloseBig(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12.7 12l6.7 6.6-.8.8-6.6-6.7-6.6 6.7-.8-.8 6.7-6.6-6.7-6.6.8-.8 6.6 6.7 6.6-6.7.8.8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItCloseCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M16.3 8.3L12.6 12l3.7 3.6-.7.7-3.7-3.6-3.6 3.6-.7-.7 3.6-3.6-3.6-3.7.7-.7 3.6 3.7 3.7-3.7zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItClose(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12.7 12l3.7 3.6-.8.8-3.6-3.7-3.6 3.7-.8-.8 3.7-3.6-3.7-3.6.8-.8 3.6 3.7 3.6-3.7.8.8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItCodeCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M19 12l-2.9 2.9-.7-.8 2.1-2.1-2.1-2.1.7-.8zM7.9 9.1L5 12l2.9 2.9.7-.8L6.5 12l2.1-2.1zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9zM9.6 16.5l1 .3 3.7-9.3-.9-.3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItCollapse(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M16.5 15.4l-4.9-4.9-4.9 4.9-.7-.8L11.6 9l5.6 5.6z"
  }));
}

function SvgItComment(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M19 3H5a2 2 0 00-2 2v10a2 2 0 002 2h2v5.4l1.7-1.7 3.7-3.7H19a2 2 0 002-2V5a2 2 0 00-2-2zm1 12a.9.9 0 01-1 1h-7l-4 4v-4H5a.9.9 0 01-1-1V5a.9.9 0 011-1h14a.9.9 0 011 1zM9 10a.9.9 0 01-1 1 .9.9 0 01-1-1 .9.9 0 011-1 .9.9 0 011 1zm4 0a1 1 0 01-2 0 1 1 0 012 0zm4 0a1 1 0 01-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItCopy(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M19.5 4H18v-.6A1.5 1.5 0 0016.5 2h-11A1.5 1.5 0 004 3.4v15.2A1.5 1.5 0 005.5 20H7v.6A1.5 1.5 0 008.5 22h11a1.5 1.5 0 001.5-1.4V5.4A1.5 1.5 0 0019.5 4zM5 18.6V3.4a.5.5 0 01.5-.4h11a.5.5 0 01.5.4v15.2a.5.5 0 01-.5.4h-11a.5.5 0 01-.5-.4zm15 2a.5.5 0 01-.5.4h-11a.5.5 0 01-.5-.4V20h8.5a1.5 1.5 0 001.5-1.4V5h1.5a.5.5 0 01.5.4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItDelete(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M15.5 4v-.5c0-.8-.7-1.5-1.5-1.5h-4c-.8 0-1.5.7-1.5 1.5V4H3v1h2v15.5c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5V5h2V4h-5.5zm-6-.5c0-.3.2-.5.5-.5h4c.3 0 .5.2.5.5V4h-5v-.5zm8.5 17c0 .3-.2.5-.5.5h-11c-.3 0-.5-.2-.5-.5V5h12v15.5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M11.5 8h1v10h-1zM8 8h1v10H8zM15 8h1v10h-1z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItDesignersItalia(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M8.7 20.2v-13h3.6v13.1l-3.6-.1zM23 10.1h-3.3v6.5c0 .2.1.4.3.6s.4.2.8.2h2.1l.2 2.8c-1.2.3-2.1.4-2.8.4-1.6 0-2.7-.3-3.3-1.1-.6-.7-.9-2-.9-3.9v-12h3.6v3.6H23v2.9zm-19.8 1c-.6 0-1.2-.2-1.6-.6-.4-.4-.6-.9-.6-1.5s.2-1.1.6-1.5c.4-.5.9-.7 1.6-.7s1.1.2 1.5.6c.4.5.6 1 .6 1.6s-.2 1.1-.6 1.5c-.4.4-.9.6-1.5.6z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 14.2L7.7 9.9l.7-.7 3.1 3.1V3h1v9.2l3.1-3 .7.7zm7-2.2v7.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V12H4v7.5A1.5 1.5 0 005.5 21h13a1.5 1.5 0 001.5-1.5V12z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItError(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M11.5 14.2V5.7h1.2v8.5zm-.1 4.1h1.2v-1.8h-1.2zM22 7.9v8.3L16.1 22H7.9L2 16.2V7.9L7.9 2h8.2zm-1 .4L15.7 3H8.3L3 8.3v7.5L8.3 21h7.4l5.3-5.2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItExchangeCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm5.1-8.9l.8.8-4.3 4.3a1.5 1.5 0 01-1.1.4 1.5 1.5 0 01-1.1-.4L9 14.7V17H8v-4h4v1H9.7l2.4 2.5h.8zm-6-4.6l-4.2 4.4-.8-.8 4.3-4.3a1.5 1.5 0 011.1-.4 1.5 1.5 0 011.1.4L15 9.3V7h1v4h-4v-1h2.3l-2.4-2.5h-.8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItExpand(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M11.6 15.4L6 9.8l.7-.8 4.9 4.9L16.5 9l.7.8z"
  }));
}

function SvgItExternalLink(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M21 3v6h-1V4.7l-7.6 7.7-.8-.8L19.3 4H15V3zm-4 16.5a.5.5 0 01-.5.5h-12a.5.5 0 01-.5-.5v-12a.5.5 0 01.5-.5H12V6H4.5A1.5 1.5 0 003 7.5v12A1.5 1.5 0 004.5 21h12a1.5 1.5 0 001.5-1.5V12h-1z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItFacebookSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M20 3H4a1 1 0 00-1 1v16a1 1 0 001 1h8.63v-6.95h-2.37v-2.74h2.34v-2a3.28 3.28 0 013.5-3.6c.705 0 1.41.04 2.11.12v2.44h-1.44c-1.13 0-1.34.53-1.34 1.32v1.74h2.7l-.35 2.72h-2.35v7H20a1 1 0 001-1V4a1 1 0 00-1-1z"
  }));
}

function SvgItFacebook(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M13.55 22v-9.11h3.07l.46-3.56h-3.53V7.05c0-1 .29-1.73 1.77-1.73h1.87V2.14A25.14 25.14 0 0014.45 2c-2.72 0-4.58 1.66-4.58 4.7v2.62H6.81v3.57h3.06V22h3.68z"
  }));
}

function SvgItFile(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M14.7 2H6.5A1.5 1.5 0 005 3.5v17A1.5 1.5 0 006.5 22h11a1.5 1.5 0 001.5-1.5V6.3zm.3 1.7L17.3 6h-1.8a.5.5 0 01-.5-.5zM17.5 21h-11a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5H14v2.5A1.5 1.5 0 0015.5 7H18v13.5a.5.5 0 01-.5.5zM8 9h8v1H8zm0 2h8v1H8zm0 2h4v1H8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItFiles(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M15.7 2H7.5A1.5 1.5 0 006 3.5V4h-.5A1.5 1.5 0 004 5.5v15A1.5 1.5 0 005.5 22h11a1.5 1.5 0 001.5-1.5V20h.5a1.5 1.5 0 001.5-1.5V6.3zm.3 1.7L18.3 6h-1.8a.5.5 0 01-.5-.5zm1 16.8a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5H6v13.5A1.5 1.5 0 007.5 20H17zm1.5-1.5h-11a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5H15v2.5A1.5 1.5 0 0016.5 7H19v11.5a.5.5 0 01-.5.5zM9 9h8v1H9zm0 2h8v1H9zm0 2h4v1H9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItFlag(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M17.1 8l3.3-5H5V2H4v20h1v-9h15.4l-3.3-5zM5 4h13.6l-2.7 4 2.7 4H5V4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItFlickrSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M20 4a3.26 3.26 0 00-2.38-1H6.38A3.26 3.26 0 004 4a3.26 3.26 0 00-1 2.37v11.25A3.26 3.26 0 004 20a3.26 3.26 0 002.39 1h11.24A3.38 3.38 0 0021 17.62V6.37A3.26 3.26 0 0020 4zm-9.56 9.77a2.5 2.5 0 01-3.51 0 2.49 2.49 0 010-3.52 2.5 2.5 0 013.51 0 2.49 2.49 0 010 3.52zm6.61 0A2.49 2.49 0 0112.82 12a2.49 2.49 0 014.24-1.76 2.49 2.49 0 010 3.52l-.01.01z"
  }));
}

function SvgItFlickr(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("circle", {
    cx: 6.73,
    cy: 12,
    r: 4.73
  }), /*#__PURE__*/createElement("circle", {
    cx: 17.27,
    cy: 12,
    r: 4.73
  }));
}

function SvgItFolder(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M20 6h-8l-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2zm1 12a.9.9 0 01-1 1H4a.9.9 0 01-1-1V6a.9.9 0 011-1h5.6l1.7 1.7.3.3H20a.9.9 0 011 1zM4 8h16v1H4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItFullscreen(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M4 20h4.5v1H3v-5.5h1zM3 8.5h1V4h4.5V3H3zM20 20h-4.5v1H21v-5.5h-1zM15.5 3v1H20v4.5h1V3z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItFunnel(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M14 22h-1v-8.65L20.05 3H4l7 10.35V22h-1v-8.35L2.05 2H22l-8 11.65z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItGithub(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12 2a10 10 0 00-3.16 19.49c.5.09.68-.22.68-.48v-1.7C6.73 19.91 6.14 18 6.14 18A2.69 2.69 0 005 16.5c-.91-.62.07-.61.07-.61a2.13 2.13 0 011.53 1 2.14 2.14 0 002.91.83 2.16 2.16 0 01.63-1.34c-2.14-.21-4.52-1.07-4.52-4.9a3.89 3.89 0 011-2.69 3.57 3.57 0 01.1-2.64s.84-.27 2.75 1a9.63 9.63 0 015 0c1.91-1.29 2.75-1 2.75-1 .37.835.405 1.78.1 2.64a3.89 3.89 0 011 2.69c0 3.84-2.34 4.68-4.57 4.93.482.49.73 1.164.68 1.85v2.75c0 .33.18.58.69.48A10 10 0 0012 2z"
  }));
}

function SvgItHearing(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M20 9a6.8 6.8 0 01-3.5 6l-2 1.1a3.3 3.3 0 00-1.5 2.7A3.2 3.2 0 019.8 22h-.6a3.4 3.4 0 01-3-2.1l.9-.5A2.3 2.3 0 009.2 21h.6a2.1 2.1 0 001.6-.7 2 2 0 00.6-1.5 4 4 0 012-3.5l2-1.2A5.9 5.9 0 0019 9a6 6 0 00-6-6 6 6 0 00-4.8 2.4l-.8-.6A7 7 0 0113 2a7 7 0 017 7zM7.5 12A5.5 5.5 0 002 6.5v1a4.5 4.5 0 010 9v1A5.5 5.5 0 007.5 12zM5 12a2.9 2.9 0 00-3-3v1a2 2 0 010 4v1a2.9 2.9 0 003-3zm5 0a8 8 0 00-8-8v1a7 7 0 010 14v1a8 8 0 008-8zm5.9.3a4.5 4.5 0 001.2-3.2 4.5 4.5 0 00-1.2-3.2 4.5 4.5 0 00-3.2-1.4A4.8 4.8 0 009.5 6l-.3.3.2.3a8.8 8.8 0 011.3 3v.4h.4a1.5 1.5 0 010 3v1a2.5 2.5 0 002.5-2.5 2.6 2.6 0 00-2-2.5 8.5 8.5 0 00-1.1-2.6 3.9 3.9 0 012.2-.9 3.5 3.5 0 012.4 1 3.5 3.5 0 011 2.6 3.5 3.5 0 01-1 2.6z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItHelpCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-1.2-4.5H12v1.8h-1.2zm4.5-8a4.2 4.2 0 01-.3 1.8 5.4 5.4 0 01-1.3 1.4L12.3 13a2.8 2.8 0 00-.4 1.2v.6H11a3 3 0 01-.2-1 2.1 2.1 0 01.5-1.2 9 9 0 011.4-1.4 6.4 6.4 0 001.2-1.3 2.6 2.6 0 00.3-1.4 1.7 1.7 0 00-.6-1.4 3.5 3.5 0 00-2-.4L9.3 7h-.5v-.8a10.2 10.2 0 013-.5 4.9 4.9 0 012.7.6 2.7 2.7 0 01.8 2.2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItHelp(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12.8 22h-1.4v-2.1h1.4zm-.1-4.9h-1.2a9.7 9.7 0 01-.1-1.7 2.7 2.7 0 01.3-1.2 5.6 5.6 0 01.7-1.3l2.3-2.1a9.6 9.6 0 001.8-2.1 4.5 4.5 0 00.5-2.3 3 3 0 00-1.1-2.6 6.2 6.2 0 00-3.4-.7 22.9 22.9 0 00-3.6.5l-1 .3-.2-1.2h.1a18.1 18.1 0 014.7-.8 7.4 7.4 0 014.3 1 4.2 4.2 0 011.4 3.5 5 5 0 01-.5 2.7 8.6 8.6 0 01-1.9 2.2 19.7 19.7 0 00-1.8 1.6 6.2 6.2 0 00-.9 1.2 2.3 2.3 0 00-.4 1.4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItHorn(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M5 9a3 3 0 000 6h.5L7 19.3A2.5 2.5 0 009.3 21h.2a1.4 1.4 0 001.2-.6 1.4 1.4 0 00.2-1.4l-1.3-4h1.8l8.6 3.8V4.7L11.4 9zm5 10.3a.7.7 0 01-.1.5l-.4.2h-.2a1.5 1.5 0 01-1.4-1l-1.3-4h1.9zM5 14a2 2 0 010-4h6v4zm14 3.2l-7-3V9.8l7-3.5zM22 9v6h-1V9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItInbox(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M4 2v14h3.7l1 2h6.6l1-2H20V2H4zm15 13h-3.3l-1 2H9.3l-1-2H5V3h14v12z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19 17h1v5H4v-5h1v4h14zM7 5h10v1H7zM7 8h10v1H7zM7 11h10v1H7z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItInfoCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-.7-15h1.5v2h-1.5zm0 3h1.5v9h-1.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItInstagram(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12 4.62l-.01.08H8.35a5.12 5.12 0 00-1.67.31c-.38.15-.72.382-1 .68-.298.28-.53.62-.68 1a5.12 5.12 0 00-.3 1.68v7.28c.01.57.114 1.134.31 1.67.15.38.382.72.68 1 .28.298.62.53 1 .68.536.196 1.1.3 1.67.31.95.05 1.24.05 3.64.05 2.4 0 2.64-.05 3.64-.05a5.12 5.12 0 001.67-.31A3.08 3.08 0 0019 17.31a5.12 5.12 0 00.3-1.68c.05-.95.05-1.24.05-3.64 0-2.4-.05-2.64-.05-3.64a5.12 5.12 0 00-.31-1.67 2.77 2.77 0 00-.68-1 2.77 2.77 0 00-1-.68 5.12 5.12 0 00-1.67-.38H12zM12 3v.05h3.71a6.9 6.9 0 012.19.42 4.64 4.64 0 012.68 2.63A6.9 6.9 0 0121 8.29c0 .96.05 1.27.05 3.71S21 14.71 21 15.71a6.9 6.9 0 01-.47 2.24 4.64 4.64 0 01-2.63 2.63 6.9 6.9 0 01-2.19.42c-.96.05-1.27.05-3.71.05S9.29 21 8.29 21a6.9 6.9 0 01-2.19-.47 4.64 4.64 0 01-2.63-2.63 6.9 6.9 0 01-.42-2.19V12 8.29a6.9 6.9 0 01.42-2.19A4.64 4.64 0 016.1 3.42 6.9 6.9 0 018.29 3H12zm0 4.38a4.62 4.62 0 110 9.24 4.62 4.62 0 010-9.24zM12 15a3 3 0 100-6 3 3 0 000 6zm4.8-6.72a1.08 1.08 0 110-2.16 1.08 1.08 0 010 2.16z"
  }));
}

function SvgItKey(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M18 10a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 111-1 .9.9 0 01-1 1zm-1-6a5.1 5.1 0 00-4.6 3H3.3l-2 2 3 3H7v-1h.3l1 1H11v-1h1.4a5.1 5.1 0 004.6 3 5 5 0 000-10zm0 9a4.1 4.1 0 01-3.8-2.7V13H10v1H8.7l-1-1H6v1H4.7l-2-2 1-1h9.4v-.3A4.1 4.1 0 0117 8a4 4 0 010 8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItLessCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 3a9 9 0 016.36 15.36A9 9 0 015.64 5.62 8.93 8.93 0 0112 3m0-1a10 10 0 107.07 2.93A9.93 9.93 0 0012 2z"
  }), /*#__PURE__*/createElement("rect", {
    x: 7,
    y: 11.25,
    width: 10,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItLink(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M13.4 13.4l-.7-.7a2.9 2.9 0 00.9-2.1 2.7 2.7 0 00-.9-2.1L9.2 4.9a3.2 3.2 0 00-4.3 0 3.2 3.2 0 000 4.3L7.8 12l-.7.7-2.9-2.8a4.2 4.2 0 010-5.7 4.2 4.2 0 015.7 0l3.5 3.6a3.6 3.6 0 011.2 2.8 3.6 3.6 0 01-1.2 2.8zm6.4 6.4a4.2 4.2 0 000-5.7l-2.9-2.8-.7.7 2.9 2.8a3.2 3.2 0 010 4.3 3.2 3.2 0 01-4.3 0l-3.5-3.6a2.7 2.7 0 01-.9-2.1 2.9 2.9 0 01.9-2.1l-.7-.7a3.6 3.6 0 00-1.2 2.8 3.6 3.6 0 001.2 2.8l3.5 3.6a3.8 3.8 0 002.8 1.1 3.9 3.9 0 002.9-1.1zm-6.7-6.7"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItLinkedinSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19.67 3H4.33A1.32 1.32 0 003 4.3v15.4A1.32 1.32 0 004.33 21h15.34A1.32 1.32 0 0021 19.7V4.3A1.32 1.32 0 0019.67 3zM8.34 18.34H5.67V9.75h2.67v8.59zM7 8.57A1.55 1.55 0 118.55 7 1.54 1.54 0 017 8.57zm11.34 9.77h-2.67v-4.18c0-1 0-2.28-1.39-2.28s-1.6 1.09-1.6 2.21v4.25H10V9.75h2.56v1.17a2.83 2.83 0 012.53-1.39c2.7 0 3.2 1.78 3.2 4.1l.05 4.71z"
  }));
}

function SvgItLinkedin(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M16.53 8.68A3.94 3.94 0 0013 10.62V9H9.37v12h3.73v-5.95c0-1.57.29-3.09 2.24-3.09 1.95 0 1.93 1.8 1.93 3.19V21H21v-6.6c0-3.23-.69-5.72-4.47-5.72zM5.16 3a2.17 2.17 0 102.16 2.18A2.16 2.16 0 005.16 3zM3.29 9v12H7V9H3.29zm13.24-.3A3.94 3.94 0 0013 10.62V9H9.37v12h3.73v-5.95c0-1.57.29-3.09 2.24-3.09 1.95 0 1.93 1.8 1.93 3.19V21H21v-6.6c0-3.23-.69-5.72-4.47-5.72v.02zM3.29 21H7V9H3.29v12zM5.16 3a2.17 2.17 0 102.16 2.18A2.16 2.16 0 005.16 3z"
  }));
}

function SvgItList(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M4 12a.9.9 0 01-1 1 1 1 0 010-2 .9.9 0 011 1zM3 4.5a.9.9 0 00-1 1 .9.9 0 001 1 .9.9 0 001-1 .9.9 0 00-1-1zm0 13a1 1 0 000 2 1 1 0 000-2zM6 5v1h16V5zm0 7.5h16v-1H6zM6 19h16v-1H6z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItLock(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M18.5 8.5H17V8A5 5 0 007 8v.5H5.5A1.5 1.5 0 004 10v8.5A1.5 1.5 0 005.5 20h13a1.5 1.5 0 001.5-1.5V10a1.5 1.5 0 00-1.5-1.5zM8 8a4 4 0 018 0v.5H8zm11 10.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h13a.5.5 0 01.5.5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12 13.25a1 1 0 11-1 1 1 1 0 011-1m0-1a2 2 0 102 2 2 2 0 00-2-2z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItLocked(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M16.5 12H16V7a4 4 0 00-8 0v5h-.5a1.1 1.1 0 00-1.1 1.1v6.8A1.1 1.1 0 007.5 21h9a1.1 1.1 0 001.1-1.1v-6.8a1.1 1.1 0 00-1.1-1.1zM9 7a3 3 0 016 0v5H9zm7.6 12.9a.1.1 0 01-.1.1h-9a.1.1 0 01-.1-.1v-6.8h9.2zM13 15.5a.8.8 0 01-.5.8v1.5h-1v-1.5a.8.8 0 01-.5-.8 1 1 0 012 0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItMail(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M20.5 5h-17A1.5 1.5 0 002 6.5v11A1.5 1.5 0 003.5 19h17a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0020.5 5zm-.3 1l-7.1 7.2a1.6 1.6 0 01-2.2 0L3.8 6zM3 17.3V6.6L8.3 12zm.7.7L9 12.7l1.2 1.2a2.7 2.7 0 003.6 0l1.2-1.2 5.3 5.3zm12-6L21 6.6v10.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItMapMarkerCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M17.7 5.3C16 2.2 12 1.1 8.9 2.8s-4.3 5.7-2.5 8.8L12 22l5.7-10.4c.5-1 .8-2 .8-3.1s-.3-2.2-.8-3.2zm-.9 5.8L12 19.9l-4.8-8.8c-.5-.8-.7-1.7-.7-2.7C6.5 5.4 9 3 12 3s5.5 2.5 5.5 5.5c0 .9-.2 1.8-.7 2.6z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12 5c-1.9 0-3.5 1.6-3.5 3.5S10.1 12 12 12s3.5-1.6 3.5-3.5S13.9 5 12 5zm0 6c-1.4 0-2.5-1.1-2.5-2.5S10.6 6 12 6s2.5 1.1 2.5 2.5S13.4 11 12 11z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItMapMarkerMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M17.7 5.3C16 2.2 12 1.1 8.9 2.8s-4.3 5.7-2.5 8.8L12 22l5.7-10.4c.5-1 .8-2 .8-3.1s-.3-2.2-.8-3.2zm-.9 5.8L12 19.9l-4.8-8.8c-.5-.8-.7-1.7-.7-2.7C6.5 5.4 9 3 12 3s5.5 2.5 5.5 5.5c0 .9-.2 1.8-.7 2.6z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItMapMarkerPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M15.1 2.8c-1-.5-2-.8-3.1-.8-3.6 0-6.5 2.9-6.5 6.5 0 1.1.3 2.2.8 3.1L12 22l5.7-10.4c1.7-3.2.5-7.1-2.6-8.8zm1.7 8.3L12 19.9l-4.8-8.8c-1.5-2.7-.5-6 2.1-7.5 2.7-1.5 6-.5 7.5 2.1.5.8.7 1.7.7 2.7 0 1-.2 1.9-.7 2.7z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.5 8h3v1h-3v3h-1V9h-3V8h3V5h1z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItMapMarker(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 22L6.3 11.6c-1.7-3.1-.6-7 2.6-8.8s7.1-.6 8.8 2.5c.5 1 .8 2 .8 3.1s-.3 2.2-.8 3.1L12 22zm0-19C9 3 6.5 5.5 6.5 8.5c0 .9.2 1.9.7 2.7L12 20l4.8-8.8c1.5-2.6.5-6-2.1-7.5-.8-.5-1.8-.7-2.7-.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItMaximizeAlt(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M15.1 18.1l.7.7-3.8 3.9-3.9-3.9.7-.7 2.7 2.7v-7.3h1v7.3zM18.9 8.1l-.8.7 2.7 2.7h-7.3v1h7.3l-2.6 2.6.7.7 3.8-3.8zM11.5 3.2v7.3h1V3.2l2.6 2.6.7-.7L12 1.3 8.1 5.1l.7.7zM10.5 12.5v-1H3.2l2.6-2.7-.6-.7L1.3 12l3.8 3.8.7-.7-2.6-2.6z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItMaximize(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M4.7 4l6.7 6.6-.7.7L4 4.7v3.8H3V3h5.5v1zM20 19.3l-6.6-6.7-.7.7 6.6 6.7h-3.8v1H21v-5.5h-1zM15.5 3v1h3.8l-6.6 6.6.7.7L20 4.7v3.8h1V3zM10.6 12.6L4 19.3v-3.8H3V21h5.5v-1H4.7l6.7-6.7z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItMediumSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M3 3h18v18H3V3zm4.3 11.36a.64.64 0 01-.17.54l-1.27 1.54v.2h3.6v-.2L8.19 14.9a.67.67 0 01-.19-.54V9.74l3.16 6.9h.37l2.71-6.9v5.5c0 .15 0 .17-.09.27l-1 1v.2h4.74v-.2l-.89-.98a.27.27 0 01-.11-.27v-6.8a.28.28 0 01.11-.27l1-.93v-.2h-3.39L12.23 13 9.52 7.06H6v.2l1.14 1.36A.5.5 0 017.3 9v5.36z"
  }));
}

function SvgItMedium(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M5 7.63A.72.72 0 004.82 7L3.13 5v-.3h5.22l4 8.84 3.54-8.84h5V5l-1.42 1.4a.43.43 0 00-.16.4v10.12a.45.45 0 00.16.41l1.4 1.37v.3h-7v-.3l1.45-1.41c.14-.14.14-.18.14-.4V8.71L11.37 19h-.55L6.12 8.71v6.88a.93.93 0 00.26.79l1.89 2.29V19H2.91v-.3l1.89-2.32a.92.92 0 00.2-.79V7.63z"
  }));
}

function SvgItMinimize(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M3 15.5h5.5V21h-1v-4.5H3zM7.5 7.5H3v1h5.5V3h-1zM15.5 21h1v-4.5H21v-1h-5.5zM16.5 7.5V3h-1v5.5H21v-1z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItMinusCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M6.9 11.5h10v1h-10zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M20 12.5H4v-1h16z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItMoreActions(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M6 10a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 010-2 1 1 0 010 2zm6-3a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 111-1 .9.9 0 01-1 1zm6-3a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 111-1 .9.9 0 01-1 1z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItMoreItems(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 18a1 1 0 11-1 1 .9.9 0 011-1m0-1a2 2 0 102 2 2 2 0 00-2-2zm0-6a1 1 0 11-1 1 .9.9 0 011-1m0-1a2 2 0 102 2 2 2 0 00-2-2zm0-6a.9.9 0 011 1 1 1 0 01-2 0 .9.9 0 011-1m0-1a2 2 0 102 2 2 2 0 00-2-2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItNote(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M18.5 4h-13A1.5 1.5 0 004 5.5v13A1.5 1.5 0 005.5 20h10.2l4.3-4.3V5.5A1.5 1.5 0 0018.5 4zM5 18.5v-13a.5.5 0 01.5-.5h13a.5.5 0 01.5.5V15h-2.5a1.5 1.5 0 00-1.5 1.5V19H5.5a.5.5 0 01-.5-.5zM18.3 16L16 18.3v-1.8a.5.5 0 01.5-.5zM16 9H8V8h8zm0 2H8v-1h8zm-2 1v1H8v-1z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItOpenSource(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12 2a10 10 0 00-3.18 19.48l1.75-5.75.29-1A3 3 0 019 12a3 3 0 016 0 3 3 0 01-1.87 2.76l.3 1 1.75 5.75A10 10 0 0012 2zm3.82 18.15l-1.49-4.91a2.15 2.15 0 00.23-.18 1.21 1.21 0 00.24-.21 1.8 1.8 0 00.19-.2 3.79 3.79 0 00.72-1.15l.11-.31a2.5 2.5 0 00.07-.26 2.67 2.67 0 00.08-.48A3.4 3.4 0 0016 12a4 4 0 00-8 0v.5a3.58 3.58 0 00.09.45 3 3 0 00.14.45 4.16 4.16 0 00.43.84c.09.13.19.25.29.37a2.57 2.57 0 00.33.33 3.94 3.94 0 00.36.3l-1.46 4.91a9 9 0 117.64 0z"
  }));
}

function SvgItPa(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M3 21h18v1H3zm0-1h18v-1H3zM22 9H2l10-7zM5.2 8h13.6L12 3.2zM6 18v-8H5v8zm4 0v-8H9v8zm5 0v-8h-1v8zm4 0v-8h-1v8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItPasswordInvisible(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M15 12a3.2 3.2 0 00-.7-1.9l.4-1.1a4.2 4.2 0 011.3 3 4 4 0 01-3.9 4l.4-1.1A2.9 2.9 0 0015 12zM3.1 12A9.8 9.8 0 0112 6.5h.4l.4-.9H12a10.9 10.9 0 00-9.8 6L2 12l.2.5a11 11 0 006.1 5.3l.3-.9A9.8 9.8 0 013.1 12zm18.7-.5a11 11 0 00-6.1-5.3l-.3.9a9.8 9.8 0 015.5 4.9 9.8 9.8 0 01-8.9 5.5h-.4l-.4.9h.8a10.9 10.9 0 009.8-6l.2-.4zM11.5 9.1l.4-1.1A4 4 0 008 12a4.2 4.2 0 001.3 3l.4-1.1A3.2 3.2 0 019 12a2.9 2.9 0 012.5-2.9zm3.1-5.7L8.5 20.3l.9.3 6.1-16.9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItPasswordVisible(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M21.8 11.5a11 11 0 00-19.6 0L2 12l.2.5a11 11 0 0019.6 0l.2-.5zm-9.8 6A9.8 9.8 0 013.1 12 9.8 9.8 0 0112 6.5a9.8 9.8 0 018.9 5.5 9.8 9.8 0 01-8.9 5.5zM12 8a4 4 0 104 4 4 4 0 00-4-4zm0 7a3 3 0 113-3 2.9 2.9 0 01-3 3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItPencil(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M20.5 3.5a2.9 2.9 0 00-2.1-.9 3.1 3.1 0 00-2.2.9L4.6 15.2l-1 5.2 5.2-1L20.5 7.8a3 3 0 000-4.3zm-5.7 2.8l.7-.7 2.9 2.9-.7.7zm-.7.8l1.1 1-8.4 8.4-1.1-1.1zM5.7 18.3a.7.7 0 00-.6-.3l.3-1.5 2.1 2.1-1.5.3a.7.7 0 00-.3-.6zm2.9 0l-1.1-1.1 8.4-8.4 1 1.1zM19.8 7.1l-.7.7-2.9-2.9.7-.7a2.2 2.2 0 011.5-.6 2 2 0 011.4.6 2.1 2.1 0 010 2.9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItPiattaforme(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12 4.14L18.94 8 12 11.86 5.06 8 12 4.14M12 3L3 8l9 5 9-5-9-5zM21 14.72l-9 5.01-9-5.01 1-.54 8 4.44 7.97-4.47 1.03.57z"
  }), /*#__PURE__*/createElement("path", {
    d: "M21 11.51l-9 5-9-5 1-.55 8 4.44 7.97-4.46 1.03.57z"
  }));
}

function SvgItPin(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M18.1 14L15 10.3V4.6L16.3 2H7.7L9 4.6v5.7L5.9 14h5.6v8h1v-8zM10 5h4v5h-4zm4.7-2l-.5 1H9.8l-.5-1zm-5 8h4.6l1.6 2H8.1z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItPlug(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M8.5 9.9l-2.8 2.8-1.1 1.1c-.6.6-.6 1.5 0 2.1L6 17.3l-3.8 3.9.7.7L6.7 18l1.4 1.4c.3.3.7.4 1.1.4.4 0 .8-.2 1.1-.4l1.1-1.1 2.8-2.8-5.7-5.6zm1 8.8c-.2.2-.5.2-.7 0l-3.5-3.5c-.2-.2-.2-.5 0-.7l.4-.4 4.2 4.2-.4.4zm-3.2-5.3l2.1-2.1 4.2 4.2-2.1 2.1-4.2-4.2zm9.6-8.8c-.6-.6-1.5-.6-2.1 0L11.3 7l1.4 1.4-2.1 2.1.7.7 2.1-2.1 1.4 1.4-2.1 2.1.7.7 2.1-2.1 1.5 1.4 2.5-2.5c.6-.6.6-1.5 0-2.1l-3.6-3.4zm2.8 4.9L17 11.3 12.7 7l1.8-1.8c.2-.2.5-.2.7 0l3.5 3.5c.2.3.2.6 0 .8zM8.5 12.7l.7.7-.7.7-.7-.7.7-.7zm2.8 2.8l-.7.7-.7-.7.7-.7.7.7zM18 6.7l-.7-.7 3.9-3.8.7.7L18 6.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItPlusCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12.4 11.5h4.5v1h-4.5V17h-1v-4.5H6.9v-1h4.5V7h1zm9.6.5A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M20 12.5h-7.5V20h-1v-7.5H4v-1h7.5V4h1v7.5H20z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItPresentation(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M4 5v10.6A2.4 2.4 0 006.4 18h3.1l-1.1 4h1l1.1-4h2.7l1.2 4h1l-1.2-4h3.5a2.3 2.3 0 002.3-2.3V5zm15 10.7a1.3 1.3 0 01-1.3 1.3H6.4A1.4 1.4 0 015 15.6V6h14zM21 3v1H3V3zm-9 13a4.5 4.5 0 10-4.5-4.5A4.5 4.5 0 0012 16zm-.5-7.9V11H8.6a3.4 3.4 0 012.9-2.9zm1 3.9V8a3.5 3.5 0 01-.5 7 3.4 3.4 0 01-3.4-3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItPrint(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M21 9.5A1.5 1.5 0 0019.5 8H17V3H7v5H4.5A1.5 1.5 0 003 9.5V16h2v3h2v2h10v-2h2v-3h2zM8 4h8v4H8zM6 18v-4h1v4zm10 2H8v-6h8v6zm2-2h-1v-4h1v4zm2-3h-1v-2H5v2H4V9.5a.5.5 0 01.5-.5h15a.5.5 0 01.5.5zM6 11h4v1H6z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItRefresh(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M21 12c0 5-4 9-9 9s-9-4-9-9 4-9 9-9c2.4 0 4.7.9 6.4 2.6.4.4.8.9 1.1 1.4h-4v1H21V2.5h-1V6c-.3-.4-.6-.7-.9-1.1C15.2 1 8.8 1 4.9 4.9S1 15.2 4.9 19.1s10.2 3.9 14.1 0c1.9-1.9 2.9-4.4 2.9-7.1H21z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItRestore(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 2C9.3 2 6.8 3 4.9 4.9c-.3.4-.6.7-.9 1.1V2.5H3V8h5.5V7h-4c.3-.5.7-.9 1.1-1.4 3.5-3.5 9.2-3.6 12.7-.1s3.6 9.2.1 12.7-9.2 3.6-12.7.1C4 16.7 3 14.4 3 12H2c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItRssSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.62 3H6.37A3.37 3.37 0 003 6.38v11.24A3.37 3.37 0 006.37 21h11.25A3.38 3.38 0 0021 17.62V6.38A3.38 3.38 0 0017.62 3zM7.5 18.75a2.25 2.25 0 112.25-2.25 2.25 2.25 0 01-2.25 2.25zm4.5 0A6.75 6.75 0 005.25 12V9.75a9 9 0 019 9zm4.5 0A11.25 11.25 0 005.25 7.5V5.25a13.5 13.5 0 0113.5 13.5z"
  }));
}

function SvgItRss(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M5.67 15.66a2.67 2.67 0 102.67 2.67 2.68 2.68 0 00-2.67-2.67z"
  }), /*#__PURE__*/createElement("path", {
    d: "M3.28 8.88a.28.28 0 00-.28.28v3.39a.29.29 0 00.28.28 7.9 7.9 0 017.89 7.89.29.29 0 00.28.28h3.41a.28.28 0 00.27-.28A11.93 11.93 0 003.28 8.88z"
  }), /*#__PURE__*/createElement("path", {
    d: "M21 20.72A17.84 17.84 0 003.28 3a.29.29 0 00-.28.28v3.49a.28.28 0 00.28.23A13.69 13.69 0 0117 20.72a.29.29 0 00.28.28h3.5a.29.29 0 00.29-.28z"
  }));
}

function SvgItSearch(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M21.9 21.1L16 15.3a8.3 8.3 0 002-5.3 8 8 0 10-8 8 8.3 8.3 0 005.3-2l5.8 5.9zM10 17a7 7 0 117-7 7 7 0 01-7 7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItSettings(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 7.5a4.5 4.5 0 104.5 4.5A4.5 4.5 0 0012 7.5zm0 8a3.5 3.5 0 113.5-3.5 3.5 3.5 0 01-3.5 3.5zm9.8-1.6A12.3 12.3 0 0022 12a12.3 12.3 0 00-.2-1.9l-2.1-.3a8.7 8.7 0 00-.7-1.7l1.3-1.7a8.7 8.7 0 00-2.7-2.7L15.9 5l-1.7-.7-.3-2.1L12 2l-1.9.2-.3 2.1-1.7.7-1.7-1.3a8.7 8.7 0 00-2.7 2.7L5 8.1a8.7 8.7 0 00-.7 1.7l-2.1.3A12.3 12.3 0 002 12a12.3 12.3 0 00.2 1.9l2.1.3a8.7 8.7 0 00.7 1.7l-1.3 1.7a8.7 8.7 0 002.7 2.7L8.1 19l1.7.7.3 2.1 1.9.2 1.9-.2.3-2.1 1.7-.7 1.7 1.3a8.7 8.7 0 002.7-2.7L19 15.9a8.7 8.7 0 00.7-1.7zm-2.9-.7l-.2.7a3.9 3.9 0 01-.6 1.5l-.3.6.4.5.8 1.1a9.3 9.3 0 01-1.4 1.4l-1.1-.8-.5-.4-.6.3a3.9 3.9 0 01-1.5.6l-.7.2v.7l-.2 1.3h-2l-.2-1.3v-.7l-.7-.2a3.9 3.9 0 01-1.5-.6l-.6-.3-.5.4-1.1.8A9.3 9.3 0 015 17.6l.8-1.1.4-.5-.3-.6a3.9 3.9 0 01-.6-1.5l-.2-.7h-.7L3.1 13a3.4 3.4 0 01-.1-1 3.4 3.4 0 01.1-1l1.3-.2h.7l.2-.7a3.9 3.9 0 01.6-1.5l.3-.6-.4-.5L5 6.4 6.4 5l1.1.8.5.4.6-.3a3.9 3.9 0 011.5-.6l.7-.2v-.7l.2-1.3h2l.2 1.3v.7l.7.2a3.9 3.9 0 011.5.6l.6.3.5-.4 1.1-.8A9.3 9.3 0 0119 6.4l-.8 1.1-.4.5.3.6a3.9 3.9 0 01.6 1.5l.2.7h.7l1.3.2a3.4 3.4 0 01.1 1 3.4 3.4 0 01-.1 1l-1.3.2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItShare(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M17.5 15a2.5 2.5 0 00-2 1l-7.6-3.4A1.3 1.3 0 008 12a1.3 1.3 0 00-.1-.6L15.5 8a2.5 2.5 0 10-.5-1.5 1.3 1.3 0 00.1.6l-7.6 3.4a2.5 2.5 0 100 3l7.6 3.4a1.3 1.3 0 00-.1.6 2.5 2.5 0 102.5-2.5zm0-10A1.5 1.5 0 0119 6.5a1.5 1.5 0 01-3 0A1.5 1.5 0 0117.5 5zm-12 8.5a1.5 1.5 0 010-3 1.5 1.5 0 010 3zm12 5.5a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItSoftware(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M20.5 3h-17A1.5 1.5 0 002 4.5v15A1.5 1.5 0 003.5 21h17a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0020.5 3zm.5 16.5a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5V8h18zM21 7H3V4.5a.5.5 0 01.5-.5h17a.5.5 0 01.5.5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12 16h5v1h-5zM12 14.06l-5.1 3.69v-1.24l3.39-2.45-3.39-2.45v-1.24l5.1 3.69zM10.29 14.06L6.9 16.51M10.29 14.06L6.9 11.61"
  }));
}

function SvgItStarFull(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 1.7L9.5 9.2H1.6L8 13.9l-2.4 7.6 6.4-4.7 6.4 4.7-2.4-7.6 6.4-4.7h-7.9L12 1.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItStarOutline(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 4.9l1.5 4.6.2.7h5.7l-4 2.9-.6.4.2.7 1.5 4.7-3.9-2.9-.6-.4-.6.4-3.9 2.9L9 14.2l.2-.7-.6-.4-4-2.9h5.7l.2-.7L12 4.9m0-3.2L9.5 9.2H1.6L8 13.9l-2.4 7.6 6.4-4.7 6.4 4.7-2.4-7.6 6.4-4.7h-7.9L12 1.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItTeamDigitale(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M23.648 24H.352A.353.353 0 010 23.648V.352C0 .158.158 0 .352 0h23.296c.194 0 .352.158.352.352v23.296a.353.353 0 01-.352.352zM5.814 11.792a1.596 1.596 0 100-3.192 1.596 1.596 0 000 3.192zM10 18.994V19h4.418C19.13 19 20 16.685 20 12.253 20 7.93 18.995 6 14.418 6H10v12.994zm4.418-10.702c2.586 0 2.838 1.11 2.838 3.955 0 2.89-.252 4.455-2.838 4.455h-1.756v-8.41h1.756z"
  }));
}

function SvgItTelegram(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 2A10 10 0 112 12 10 10 0 0112 2zm-5.47 9.89c2.91-1.27 4.86-2.1 5.83-2.51C15.14 8.23 15.71 8 16.09 8a.67.67 0 01.39.12.4.4 0 01.14.27 2.12 2.12 0 010 .39c-.16 1.58-.81 5.42-1.14 7.19-.14.75-.41 1-.68 1-.58.05-1-.39-1.59-.76-.88-.57-1.37-.93-2.23-1.5s-.34-1 .22-1.59c.17-.12 2.72-2.43 2.8-2.64a.19.19 0 000-.18.26.26 0 00-.21 0c-.09 0-1.49 1-4.22 2.79a1.83 1.83 0 01-1.08.4 7 7 0 01-1.56-.37c-.62-.2-1.12-.31-1.08-.65-.04-.2.2-.39.68-.58z",
    fillRule: "evenodd"
  }));
}

function SvgItTelephone(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M5 3h.18M20 11.56A7.59 7.59 0 0012.48 4h-.06a.49.49 0 00-.49.48.5.5 0 00.49.51A6.61 6.61 0 0119 11.62a.51.51 0 00.54.46.49.49 0 00.45-.46s.01-.04.01-.06z"
  }), /*#__PURE__*/createElement("path", {
    d: "M16.93 11.68a4.5 4.5 0 00-4.48-4.48.51.51 0 000 1 3.5 3.5 0 013.49 3.49.5.5 0 00.5.5.51.51 0 00.5-.51zM15.68 21.19a13.32 13.32 0 01-12.8-13.1.92.92 0 01.62-.88c1.74-.56 4-1 4.7.06a7.39 7.39 0 01.85 2.91v.21a1.48 1.48 0 01-.7 1.68.81.81 0 00-.49.71 12.55 12.55 0 003.38 3.51.88.88 0 00.48-.56c.09-.53.58-1 1.7-.85h.21a7 7 0 012.85.87c1 .72.62 3 .09 4.72a1 1 0 01-.89.72zM6.55 7.52a9.5 9.5 0 00-2.78.55 12.41 12.41 0 0011.91 12.22c.73-2.26.66-3.54.31-3.78a6.66 6.66 0 00-2.46-.72h-.22c-.32 0-.65 0-.68.12a1.9 1.9 0 01-1.27 1.34l-.21.07-.15-.15a13.44 13.44 0 01-3.9-4L7 13a1.68 1.68 0 011-1.7c.12-.07.33-.18.25-.75v-.22a6.84 6.84 0 00-.7-2.54c-.2-.18-.55-.27-1-.27z"
  }));
}

function SvgItTool(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M7.7 5a3.1 3.1 0 011.7.5 3.1 3.1 0 011.6 3 3 3 0 00.8 2.4l6.3 6.3a1 1 0 01.2 1.3 1 1 0 01-.8.5.9.9 0 01-.7-.3l-6.4-6.4a3 3 0 00-2.1-.8h-.6a2.8 2.8 0 01-2.2-1h2.7V6.4H5.1a2.7 2.7 0 011.1-1A2.8 2.8 0 017.7 5m0-1a4.6 4.6 0 00-2 .5 4.1 4.1 0 00-2.1 2.9h3.6v2.1H3.7a5.4 5.4 0 001 1.8 4.4 4.4 0 003 1.2h.6a2.4 2.4 0 011.4.5l6.4 6.4a2 2 0 001.4.6 1.9 1.9 0 001.6-.9 2 2 0 00-.3-2.6l-6.3-6.3a1.8 1.8 0 01-.5-1.6 4.4 4.4 0 00-2-4A4.6 4.6 0 007.7 4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItTwitterSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19.5 22h-15A2.5 2.5 0 012 19.5v-15A2.5 2.5 0 014.5 2h15A2.5 2.5 0 0122 4.5v15a2.5 2.5 0 01-2.5 2.5zm-9.82-4.92A7.24 7.24 0 0017 9.79v-.33a5.22 5.22 0 001.28-1.33 5.22 5.22 0 01-1.48.4 2.56 2.56 0 001.14-1.42 4.93 4.93 0 01-1.64.62 2.53 2.53 0 00-1.86-.81 2.57 2.57 0 00-2.57 2.57c.003.195.026.39.07.58a7.26 7.26 0 01-5.32-2.68 2.59 2.59 0 00.8 3.43 2.78 2.78 0 01-1.16-.32 2.57 2.57 0 002.05 2.52 2.46 2.46 0 01-1.15.04 2.55 2.55 0 002.39 1.78A5.13 5.13 0 016.37 16a6.08 6.08 0 01-.61 0 7.23 7.23 0 003.92 1.14v-.06z"
  }));
}

function SvgItTwitter(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M8.08 20a10.93 10.93 0 0011-11v-.5a8 8 0 001.92-2 7.85 7.85 0 01-2.22.61A3.89 3.89 0 0020.48 5a8 8 0 01-2.48.91 3.87 3.87 0 00-6.59 3.52 11 11 0 01-8-4 3.85 3.85 0 001.19 5.16 3.76 3.76 0 01-1.75-.48A3.87 3.87 0 006 13.91a3.73 3.73 0 01-1 .14 4.3 4.3 0 01-.73-.05 3.87 3.87 0 003.61 2.68 7.73 7.73 0 01-4.8 1.66 7 7 0 01-.92-.06A10.9 10.9 0 008.08 20"
  }));
}

function SvgItUnlocked(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M16.5 12H16V6a4 4 0 00-8 0v3h1V6a3 3 0 016 0v6H7.5a1.1 1.1 0 00-1.1 1.1v6.8A1.1 1.1 0 007.5 21h9a1.1 1.1 0 001.1-1.1v-6.8a1.1 1.1 0 00-1.1-1.1zm.1 7.9a.1.1 0 01-.1.1h-9a.1.1 0 01-.1-.1v-6.8h9.2zM13 15.5a.8.8 0 01-.5.8v1.5h-1v-1.5a.8.8 0 01-.5-.8 1 1 0 012 0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M8.4 7.3l-.7-.7L12 2.3l4.3 4.3-.7.7-3.1-3.1v9.3h-1V4.2zM19 12v7.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V12H4v7.5A1.5 1.5 0 005.5 21h13a1.5 1.5 0 001.5-1.5V12z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItUser(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 13a4 4 0 004-4V6a4 4 0 00-8 0v3a4 4 0 004 4zM9 6a3 3 0 016 0v3a3 3 0 01-6 0zm11 16h-1a7 7 0 00-14 0H4a8 8 0 0116 0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItVideo(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M17.5 7.3V6A1.5 1.5 0 0016 4.5H5.5A1.5 1.5 0 004 6v8a1.5 1.5 0 001.5 1.5h3.4L7.4 21h1l1.6-5.5h1.8l1.6 5.5h1l-1.6-5.5H16a1.5 1.5 0 001.5-1.5v-1.3l4 1.5V5.8zm3 5.5l-4-1.5V14a.5.5 0 01-.5.5H5.5A.5.5 0 015 14V6a.5.5 0 01.5-.5H16a.5.5 0 01.5.5v2.7l4-1.5zM2 8h1v4H2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItWarningCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-.5-6.8V5.7h1.2v8.5zm-.1 2.3h1.2v1.8h-1.2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItWarning(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M12.5 17h-1V2h1zm0 3h-1v2h1z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItWhatsappSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M16 8.07a5.34 5.34 0 00-9.11 3.77 5.28 5.28 0 00.82 2.84l.12.2-.53 2 2-.53.2.11c.82.49 1.756.75 2.71.75A5.34 5.34 0 0016 8.07zm-.83 5.83a1.66 1.66 0 01-1.08.76 2.23 2.23 0 01-1-.06c-.23-.08-.53-.18-.91-.34a7.16 7.16 0 01-2.78-2.42 3.13 3.13 0 01-.66-1.66 1.83 1.83 0 01.56-1.34.59.59 0 01.43-.2H10c.1 0 .23 0 .36.27.13.27.45 1.11.49 1.19a.3.3 0 010 .28 1.2 1.2 0 01-.16.27c-.08.1-.17.21-.24.28-.07.07-.17.17-.07.33.239.413.54.787.89 1.11.38.34.816.612 1.29.8.16.08.25.06.34 0 .09-.06.4-.47.51-.63.11-.16.21-.14.36-.08.15.06.94.44 1.1.52.16.08.26.12.3.19a1.36 1.36 0 01-.03.73h.03z"
  }), /*#__PURE__*/createElement("path", {
    d: "M21 7.09a8.26 8.26 0 00-.09-1.15 3.49 3.49 0 00-1.85-2.51 3.89 3.89 0 00-1-.32A8.36 8.36 0 0016.91 3H7.09a8.26 8.26 0 00-1.15.09A3.49 3.49 0 003.43 5a3.89 3.89 0 00-.32 1A8.36 8.36 0 003 7.09v9.82c.003.385.033.77.09 1.15A3.49 3.49 0 005 20.57a3.89 3.89 0 001 .32c.384.06.771.094 1.16.1h9.82a8.26 8.26 0 001.15-.09 3.49 3.49 0 002.51-1.85 3.89 3.89 0 00.32-1 8.36 8.36 0 00.1-1.16V7.57c-.06-.1-.06-.31-.06-.48zm-8.8 11.17a6.39 6.39 0 01-3.06-.78l-3.41.89.92-3.32a6.33 6.33 0 01-.86-3.21 6.41 6.41 0 0111-4.53 6.33 6.33 0 011.88 4.54 6.42 6.42 0 01-6.47 6.41z"
  }));
}

function SvgItWhatsapp(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19.09 4.63a10 10 0 00-15.68 12L2 21.8l5.28-1.38A10 10 0 0012 21.63a10 10 0 007.05-17h.04zM12 20a8.18 8.18 0 01-4.21-1.16l-.31-.18-3.13.83.84-3.06-.19-.36A8.28 8.28 0 1112 20zm4.54-6.2c-.25-.13-1.47-.73-1.7-.81-.23-.08-.39-.13-.56.12-.246.347-.51.68-.79 1-.14.16-.29.18-.54.06a6.92 6.92 0 01-2-1.23 7.27 7.27 0 01-1.38-1.73c-.15-.25 0-.38.11-.51s.25-.29.37-.43a1.51 1.51 0 00.25-.42.46.46 0 000-.43c-.04-.2-.54-1.42-.75-1.92-.21-.5-.4-.42-.56-.43h-.47a1 1 0 00-.67.31A2.81 2.81 0 007 9.45 4.73 4.73 0 008 12a11 11 0 004.25 3.76c.464.2.938.378 1.42.53a3.28 3.28 0 001.56.09 2.54 2.54 0 001.68-1.18 2.09 2.09 0 00.15-1.2c-.06-.07-.23-.13-.48-.25l-.04.05z"
  }));
}

function SvgItWifi(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M22 19h-1c0-8.8-7.2-16-16-16V2c9.4 0 17 7.6 17 17z"
  }), /*#__PURE__*/createElement("path", {
    d: "M5 7v1c6.1 0 11 4.9 11 11h1c0-6.6-5.4-12-12-12zM5 12v1c3.3 0 6 2.7 6 6h1c0-3.9-3.1-7-7-7zM5 17c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  }), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

function SvgItYoutube(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M21.56 7.2a2.5 2.5 0 00-1.76-1.77C18.24 5 12 5 12 5s-6.24 0-7.8.42A2.5 2.5 0 002.44 7.2 25.72 25.72 0 002 12c-.01 1.61.13 3.217.42 4.8a2.5 2.5 0 001.78 1.77C5.76 19 12 19 12 19s6.24 0 7.8-.42a2.5 2.5 0 001.76-1.77A25.72 25.72 0 0022 12a25.72 25.72 0 00-.44-4.8zM10 15V9l5.19 3L10 15z"
  }));
}

function SvgItZoomIn(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M10.4 9.5h3.3v1h-3.3v3.2h-1v-3.2H6.2v-1h3.2V6.2h1zm10.7 12.4L15.3 16a8.3 8.3 0 01-5.3 2 8 8 0 118-8 8.3 8.3 0 01-2 5.3l5.9 5.8zM17 10a7 7 0 10-7 7 7 7 0 007-7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SvgItZoomOut(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/createElement("path", {
    d: "M6.2 9.5h7.5v1H6.2zm14.9 12.4L15.3 16a8.3 8.3 0 01-5.3 2 8 8 0 118-8 8.3 8.3 0 01-2 5.3l5.9 5.8zM17 10a7 7 0 10-7 7 7 7 0 007-7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

var Svgs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ItArrowDownCircle: SvgItArrowDownCircle,
  ItArrowDownTriangle: SvgItArrowDownTriangle,
  ItArrowDown: SvgItArrowDown,
  ItArrowLeftCircle: SvgItArrowLeftCircle,
  ItArrowLeftTriangle: SvgItArrowLeftTriangle,
  ItArrowLeft: SvgItArrowLeft,
  ItArrowRightCircle: SvgItArrowRightCircle,
  ItArrowRightTriangle: SvgItArrowRightTriangle,
  ItArrowRight: SvgItArrowRight,
  ItArrowUpCircle: SvgItArrowUpCircle,
  ItArrowUpTriangle: SvgItArrowUpTriangle,
  ItArrowUp: SvgItArrowUp,
  ItBan: SvgItBan,
  ItBehance: SvgItBehance,
  ItBookmark: SvgItBookmark,
  ItBox: SvgItBox,
  ItBurger: SvgItBurger,
  ItCalendar: SvgItCalendar,
  ItCamera: SvgItCamera,
  ItCard: SvgItCard,
  ItChartLine: SvgItChartLine,
  ItCheckCircle: SvgItCheckCircle,
  ItCheck: SvgItCheck,
  ItChevronLeft: SvgItChevronLeft,
  ItChevronRight: SvgItChevronRight,
  ItClip: SvgItClip,
  ItClock: SvgItClock,
  ItCloseBig: SvgItCloseBig,
  ItCloseCircle: SvgItCloseCircle,
  ItClose: SvgItClose,
  ItCodeCircle: SvgItCodeCircle,
  ItCollapse: SvgItCollapse,
  ItComment: SvgItComment,
  ItCopy: SvgItCopy,
  ItDelete: SvgItDelete,
  ItDesignersItalia: SvgItDesignersItalia,
  ItDownload: SvgItDownload,
  ItError: SvgItError,
  ItExchangeCircle: SvgItExchangeCircle,
  ItExpand: SvgItExpand,
  ItExternalLink: SvgItExternalLink,
  ItFacebookSquare: SvgItFacebookSquare,
  ItFacebook: SvgItFacebook,
  ItFile: SvgItFile,
  ItFiles: SvgItFiles,
  ItFlag: SvgItFlag,
  ItFlickrSquare: SvgItFlickrSquare,
  ItFlickr: SvgItFlickr,
  ItFolder: SvgItFolder,
  ItFullscreen: SvgItFullscreen,
  ItFunnel: SvgItFunnel,
  ItGithub: SvgItGithub,
  ItHearing: SvgItHearing,
  ItHelpCircle: SvgItHelpCircle,
  ItHelp: SvgItHelp,
  ItHorn: SvgItHorn,
  ItInbox: SvgItInbox,
  ItInfoCircle: SvgItInfoCircle,
  ItInstagram: SvgItInstagram,
  ItKey: SvgItKey,
  ItLessCircle: SvgItLessCircle,
  ItLink: SvgItLink,
  ItLinkedinSquare: SvgItLinkedinSquare,
  ItLinkedin: SvgItLinkedin,
  ItList: SvgItList,
  ItLock: SvgItLock,
  ItLocked: SvgItLocked,
  ItMail: SvgItMail,
  ItMapMarkerCircle: SvgItMapMarkerCircle,
  ItMapMarkerMinus: SvgItMapMarkerMinus,
  ItMapMarkerPlus: SvgItMapMarkerPlus,
  ItMapMarker: SvgItMapMarker,
  ItMaximizeAlt: SvgItMaximizeAlt,
  ItMaximize: SvgItMaximize,
  ItMediumSquare: SvgItMediumSquare,
  ItMedium: SvgItMedium,
  ItMinimize: SvgItMinimize,
  ItMinusCircle: SvgItMinusCircle,
  ItMinus: SvgItMinus,
  ItMoreActions: SvgItMoreActions,
  ItMoreItems: SvgItMoreItems,
  ItNote: SvgItNote,
  ItOpenSource: SvgItOpenSource,
  ItPa: SvgItPa,
  ItPasswordInvisible: SvgItPasswordInvisible,
  ItPasswordVisible: SvgItPasswordVisible,
  ItPencil: SvgItPencil,
  ItPiattaforme: SvgItPiattaforme,
  ItPin: SvgItPin,
  ItPlug: SvgItPlug,
  ItPlusCircle: SvgItPlusCircle,
  ItPlus: SvgItPlus,
  ItPresentation: SvgItPresentation,
  ItPrint: SvgItPrint,
  ItRefresh: SvgItRefresh,
  ItRestore: SvgItRestore,
  ItRssSquare: SvgItRssSquare,
  ItRss: SvgItRss,
  ItSearch: SvgItSearch,
  ItSettings: SvgItSettings,
  ItShare: SvgItShare,
  ItSoftware: SvgItSoftware,
  ItStarFull: SvgItStarFull,
  ItStarOutline: SvgItStarOutline,
  ItTeamDigitale: SvgItTeamDigitale,
  ItTelegram: SvgItTelegram,
  ItTelephone: SvgItTelephone,
  ItTool: SvgItTool,
  ItTwitterSquare: SvgItTwitterSquare,
  ItTwitter: SvgItTwitter,
  ItUnlocked: SvgItUnlocked,
  ItUpload: SvgItUpload,
  ItUser: SvgItUser,
  ItVideo: SvgItVideo,
  ItWarningCircle: SvgItWarningCircle,
  ItWarning: SvgItWarning,
  ItWhatsappSquare: SvgItWhatsappSquare,
  ItWhatsapp: SvgItWhatsapp,
  ItWifi: SvgItWifi,
  ItYoutube: SvgItYoutube,
  ItZoomIn: SvgItZoomIn,
  ItZoomOut: SvgItZoomOut
});

var kebabCase = function kebabCase(string) {
  return string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
}; // Icons are stored with names in PascalCase, but icon names are in kebab-case
// Here's the remap of the icons from PascalCase to kebab-case


var icons = Object.keys(Svgs).reduce(function (memo, pascalName) {
  memo[kebabCase(pascalName)] = Svgs[pascalName];
  return memo;
}, {});
var iconsList = Object.keys(icons);
var propTypes$j = {
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  padding: PropTypes.bool
};
var defaultProps$h = {
  color: '',
  size: '',
  icon: '',
  padding: false
};

var EmptyIcon = function EmptyIcon(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
};

var Icon = function Icon(_ref) {
  var _classNames;

  var color = _ref.color,
      size = _ref.size,
      icon = _ref.icon,
      className = _ref.className,
      padding = _ref.padding,
      attributes = _objectWithoutPropertiesLoose(_ref, ["color", "size", "icon", "className", "padding"]);

  var classes = classnames('icon', className, (_classNames = {}, _classNames["icon-" + color] = color, _classNames["icon-" + size] = size, _classNames['icon-padded'] = padding, _classNames), size);

  if (!icons[icon]) {
    console.error("Icon \"" + icon + "\" not found. Check on https://rb.gy/lcdkyi for the full icon list.");
    return /*#__PURE__*/React__default.createElement(EmptyIcon, _extends({
      className: classes
    }, attributes));
  }

  var IconComponent = icons[icon];
  return /*#__PURE__*/React__default.createElement(IconComponent, _extends({
    className: classes
  }, attributes));
};

Icon.propTypes = propTypes$j;
Icon.defaultProps = defaultProps$h;
var propTypes$k = {
  /** Utilizzarlo in caso di utilizzo di componenti personalizzati */
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  /** Classi aggiuntive da usare per il componente HeaderBrand */
  className: PropTypes.string,

  /** Da usare per la sovrascrittura di classi predefinite */
  cssModule: PropTypes.object,

  /** Da usare con il componente Header Nav in versione "responsive" */
  responsive: PropTypes.bool,

  /** Da utilizzare per specificare URL risorsa esterna. */
  href: PropTypes.string,

  /** Icona da utilizzare nel componente. Utilizzata unicamente quando l'Header è di tipo Center.  */
  iconName: PropTypes.string,

  /** Elementi React da renderizzare al proprio interno. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
var defaultProps$i = {
  tag: 'a',
  responsive: false
};

var HeaderBrand = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(HeaderBrand, _PureComponent);

  function HeaderBrand() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = HeaderBrand.prototype;

  _proto.addChildClasses = function addChildClasses(child, i) {
    // convention here: first item is the main title, while others subtext
    var className = classnames(child.props.className, 'no_toc', {
      'd-none d-md-block': i
    } // subtext is anything but first element
    );
    var props = {
      className: className
    };
    return /*#__PURE__*/React__default.cloneElement(child, props);
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        className = _this$props.className,
        href = _this$props.href,
        iconName = _this$props.iconName,
        children = _this$props.children,
        responsive = _this$props.responsive,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["className", "href", "iconName", "children", "responsive"]);

    var type = this.context.type;

    if (type !== CENTER) {
      var classes = classnames('d-lg-block', className, {
        'd-none': !responsive
      });
      return /*#__PURE__*/React__default.createElement(NavbarBrand, _extends({
        className: classes,
        href: href
      }, attributes), children);
    }

    return /*#__PURE__*/React__default.createElement("div", {
      className: "it-brand-wrapper"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: href
    }, iconName && /*#__PURE__*/React__default.createElement(Icon, {
      icon: iconName
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "it-brand-text"
    }, React__default.Children.map(children, function (child, i) {
      return _this.addChildClasses(child, i);
    }))));
  };

  return HeaderBrand;
}(PureComponent);

_defineProperty(HeaderBrand, "propTypes", propTypes$k);

_defineProperty(HeaderBrand, "defaultProps", defaultProps$i);

_defineProperty(HeaderBrand, "contextType", HeaderContext);

var propTypes$l = {
  /** Classi addizionali per il componente HeaderContent */
  className: PropTypes.string,

  /** Da utilizzare per indicare che all'interno dell'Header verrà utilizzato un Megamenu */
  megamenu: PropTypes.bool,

  /** Parametro per il controllo responsive del componente: valori Bootstrap standard sono "sm", "md", "lg", "xl" */
  expand: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
var defaultProps$j = {};

var HeaderContent = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(HeaderContent, _PureComponent);

  function HeaderContent() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = HeaderContent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        megamenu = _this$props.megamenu,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["className", "megamenu"]);

    var type = this.context.type;
    var classes = classnames(className, {
      'it-header-slim-wrapper-content': type === SLIM,
      'it-header-center-content-wrapper': type === CENTER,
      navbar: type === NAVBAR,
      'has-megamenu': megamenu
    });
    var Content = type === NAVBAR ? /*#__PURE__*/React__default.createElement(Navbar, _extends({
      className: classes
    }, attributes)) : /*#__PURE__*/React__default.createElement("div", _extends({
      className: classes
    }, attributes));
    return /*#__PURE__*/React__default.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "col-12"
    }, Content)));
  };

  return HeaderContent;
}(PureComponent);

_defineProperty(HeaderContent, "propTypes", propTypes$l);

_defineProperty(HeaderContent, "defaultProps", defaultProps$j);

_defineProperty(HeaderContent, "contextType", HeaderContext);

var propTypes$m = {
  /** Classi addizionali per il componente HeaderLinkZone, applicata all'element "nav" annidato */
  className: PropTypes.string
};
var defaultProps$k = {};

var HeaderLinkZone = function HeaderLinkZone(_ref) {
  var className = _ref.className,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className"]);

  var classes = classnames(className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "nav-mobile"
  }, /*#__PURE__*/React__default.createElement("nav", _extends({
    className: classes
  }, attributes)));
};

HeaderLinkZone.propTypes = propTypes$m;
HeaderLinkZone.defaultProps = defaultProps$k;
var propTypes$n = {
  /** Classi addizionali per il componente HeaderRightZone */
  className: PropTypes.string
};
var defaultProps$l = {};

var HeaderRightZone = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(HeaderRightZone, _PureComponent);

  function HeaderRightZone() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = HeaderRightZone.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var type = this.context.type;
    var classes = classnames(className, {
      // BI >= 1.3.6
      'it-header-slim-right-zone': type === SLIM,
      // BI < 1.3.6
      'header-slim-right-zone': type === SLIM,
      'it-right-zone': type !== SLIM
    });
    return /*#__PURE__*/React__default.createElement("div", _extends({
      className: classes
    }, attributes));
  };

  return HeaderRightZone;
}(PureComponent);

_defineProperty(HeaderRightZone, "propTypes", propTypes$n);

_defineProperty(HeaderRightZone, "defaultProps", defaultProps$l);

_defineProperty(HeaderRightZone, "contextType", HeaderContext);

var propTypes$o = {
  /** Classi addizionali per il componente HeaderSearch */
  className: PropTypes.string,

  /** Etichetta di testo da applicare all'elemento. In caso di stringa vuota non verrà mostrato alcun testo */
  label: PropTypes.string,

  /** Nome dell'icona da utilizzare */
  iconName: PropTypes.string,

  /** Indirizzo di indirizzamento al click dell'icona */
  href: PropTypes.string
};
var defaultProps$m = {
  iconName: 'it-search'
};

var HeaderSearch = function HeaderSearch(_ref) {
  var className = _ref.className,
      label = _ref.label,
      href = _ref.href,
      iconName = _ref.iconName,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "label", "href", "iconName"]);

  var classes = classnames('it-search-wrapper', className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, attributes), label && /*#__PURE__*/React__default.createElement("span", {
    className: "d-none d-md-block"
  }, label), /*#__PURE__*/React__default.createElement("a", {
    className: "search-link rounded-icon",
    "aria-label": label,
    href: href
  }, /*#__PURE__*/React__default.createElement(Icon, {
    icon: iconName
  })));
};

HeaderSearch.propTypes = propTypes$o;
HeaderSearch.defaultProps = defaultProps$m;
var propTypes$p = {
  /** Classi addizionali per il componente HeaderSocialsZone, verrà applicato all'elemento wrapper più esterno. */
  className: PropTypes.string,

  /** Etichetta utilizzata per presentare i social presenti. In caso di stringa vuota non verrà mostrata alcuna etichetta */
  label: PropTypes.string,

  /** Utilizzato per elencare i social da mostrare */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
var defaultProps$n = {};

var HeaderSocialsZone = function HeaderSocialsZone(_ref) {
  var className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "children", "label"]);

  var classes = classnames('it-socials d-none d-md-flex', className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, attributes), label && /*#__PURE__*/React__default.createElement("span", null, label), children);
};

HeaderSocialsZone.propTypes = propTypes$p;
HeaderSocialsZone.defaultProps = defaultProps$n;
var propTypes$q = {
  /** Tipo di elemento DOM da utilizzare: di default "a" per Header Slim, "button" per altri tipi di Header.
   * Se fornito questo sovrascriverà il valore di default.
   */
  tag: PropTypes.string,

  /** Indica l'attributo "type" sull'elemento DOM. Di default '' per Header Slim, "button" per altri tipi di Header.
   * Se fornito questo sovrascriverà il valore di default.
   */
  type: PropTypes.string,

  /** Classi addizionali per il componente HeaderToggler */
  className: PropTypes.string
};
var defaultProps$o = {};

var HeaderToggler = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(HeaderToggler, _PureComponent);

  function HeaderToggler() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = HeaderToggler.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        tag = _this$props.tag,
        type = _this$props.type,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["className", "tag", "type"]);

    var HeaderType = this.context.type;
    var BUTTON = 'button';
    var defaultTag = HeaderType === SLIM ? 'a' : BUTTON;
    var defaultType = HeaderType === SLIM ? '' : BUTTON;
    var classes = classnames({
      'it-opener d-lg-none': HeaderType === SLIM,
      'custom-navbar-toggler': HeaderType === NAVBAR
    }, className);
    return /*#__PURE__*/React__default.createElement(NavbarToggler, _extends({
      className: classes
    }, attributes, {
      tag: tag || defaultTag,
      type: type || defaultType,
      href: "#"
    }));
  };

  return HeaderToggler;
}(PureComponent);

_defineProperty(HeaderToggler, "propTypes", propTypes$q);

_defineProperty(HeaderToggler, "defaultProps", defaultProps$o);

_defineProperty(HeaderToggler, "contextType", HeaderContext);

function Hero(props) {
  return /*#__PURE__*/React__default.createElement(Jumbotron, props);
}

Hero.defaultProps = Jumbotron.defaultProps;
Hero.propTypes = Jumbotron.propTypes;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually

var isBuffer_1 = function isBuffer_1(obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};

function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
} // For Node v0.10 support. Remove this eventually.


function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

var toString = Object.prototype.toString;
/**
 * Get the native `typeof` a value.
 *
 * @param  {*} `val`
 * @return {*} Native javascript type
 */

var kindOf = function kindOf(val) {
  // primitivies
  if (typeof val === 'undefined') {
    return 'undefined';
  }

  if (val === null) {
    return 'null';
  }

  if (val === true || val === false || val instanceof Boolean) {
    return 'boolean';
  }

  if (typeof val === 'string' || val instanceof String) {
    return 'string';
  }

  if (typeof val === 'number' || val instanceof Number) {
    return 'number';
  } // functions


  if (typeof val === 'function' || val instanceof Function) {
    return 'function';
  } // array


  if (typeof Array.isArray !== 'undefined' && Array.isArray(val)) {
    return 'array';
  } // check for instances of RegExp and Date before calling `toString`


  if (val instanceof RegExp) {
    return 'regexp';
  }

  if (val instanceof Date) {
    return 'date';
  } // other objects


  var type = toString.call(val);

  if (type === '[object RegExp]') {
    return 'regexp';
  }

  if (type === '[object Date]') {
    return 'date';
  }

  if (type === '[object Arguments]') {
    return 'arguments';
  }

  if (type === '[object Error]') {
    return 'error';
  } // buffer


  if (isBuffer_1(val)) {
    return 'buffer';
  } // es6: Map, WeakMap, Set, WeakSet


  if (type === '[object Set]') {
    return 'set';
  }

  if (type === '[object WeakSet]') {
    return 'weakset';
  }

  if (type === '[object Map]') {
    return 'map';
  }

  if (type === '[object WeakMap]') {
    return 'weakmap';
  }

  if (type === '[object Symbol]') {
    return 'symbol';
  } // typed arrays


  if (type === '[object Int8Array]') {
    return 'int8array';
  }

  if (type === '[object Uint8Array]') {
    return 'uint8array';
  }

  if (type === '[object Uint8ClampedArray]') {
    return 'uint8clampedarray';
  }

  if (type === '[object Int16Array]') {
    return 'int16array';
  }

  if (type === '[object Uint16Array]') {
    return 'uint16array';
  }

  if (type === '[object Int32Array]') {
    return 'int32array';
  }

  if (type === '[object Uint32Array]') {
    return 'uint32array';
  }

  if (type === '[object Float32Array]') {
    return 'float32array';
  }

  if (type === '[object Float64Array]') {
    return 'float64array';
  } // must be a plain object


  return 'object';
};

var isNumber = function isNumber(num) {
  var type = kindOf(num);

  if (type === 'string') {
    if (!num.trim()) return false;
  } else if (type !== 'number') {
    return false;
  }

  return num - num + 1 >= 0;
};

var propTypes$r = {
  value: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  infoText: PropTypes.string,
  wrapperClass: PropTypes.string,
  activeClass: PropTypes.string,
  infoTextClass: PropTypes.string,
  children: PropTypes.node
};
var defaultProps$p = {};

var InputContainer = function InputContainer(_ref) {
  var id = _ref.id,
      activeClass = _ref.activeClass,
      label = _ref.label,
      infoTextClass = _ref.infoTextClass,
      infoText = _ref.infoText,
      wrapperClass = _ref.wrapperClass,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, children, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: activeClass
  }, label), /*#__PURE__*/React__default.createElement("small", {
    className: infoTextClass
  }, infoText));
};

InputContainer.propTypes = propTypes$r;
InputContainer.defaultProps = defaultProps$p;
var mapToCssModules = Util.mapToCssModules;

function getFormControlClassInternal(_ref) {
  var plaintext = _ref.plaintext,
      staticInput = _ref.staticInput,
      type = _ref.type,
      addon = _ref.addon;
  var formControlClass = 'form-control';

  if (plaintext || staticInput) {
    return formControlClass + "-plaintext";
  }

  if (type === 'file') {
    return formControlClass + "-file";
  }

  if (['radio', 'checkbox'].indexOf(type) > -1) {
    if (addon) {
      return null;
    }
  }

  return formControlClass;
}

function getFormControlClass(props, cssModule) {
  return mapToCssModules(getFormControlClassInternal(props), cssModule);
}

function getInfoTextControlClass(_ref2, cssModule) {
  var valid = _ref2.valid,
      invalid = _ref2.invalid;
  return mapToCssModules(classnames({
    'form-text text-muted': valid || invalid
  }), cssModule);
}

function getTag(_ref3) {
  var tag = _ref3.tag,
      plaintext = _ref3.plaintext,
      staticInput = _ref3.staticInput,
      type = _ref3.type;

  if (tag) {
    return tag;
  }

  if (['radio', 'checkbox'].indexOf(type) > -1) {
    return 'input';
  }

  if (staticInput) {
    return 'p';
  }

  return 'input';
}

function getClasses(className, _ref4, cssModule) {
  var _classNames;

  var isFocused = _ref4.isFocused,
      valid = _ref4.valid,
      invalid = _ref4.invalid,
      bsSize = _ref4.bsSize,
      placeholder = _ref4.placeholder,
      value = _ref4.value,
      label = _ref4.label,
      infoText = _ref4.infoText,
      normalized = _ref4.normalized,
      inputPassword = _ref4.inputPassword,
      formControlClass = _ref4.formControlClass,
      infoTextControlClass = _ref4.infoTextControlClass;
  var hasPlainCondition = placeholder || label || infoText;
  var baseCondition = hasPlainCondition && !normalized && !inputPassword;
  var passwordOnlyCondition = inputPassword && !hasPlainCondition && !normalized;
  var normalizedOnlyCondition = normalized && !hasPlainCondition && !inputPassword;
  var classes = mapToCssModules(classnames(className, (_classNames = {
    'is-invalid': invalid,
    'is-valid': valid
  }, _classNames["form-control-" + bsSize] = bsSize, _classNames), formControlClass), cssModule);
  var wrapperClass = mapToCssModules(classnames(className, 'form-group'), cssModule);
  var infoTextClass = mapToCssModules(classnames({
    'valid-feedback': valid,
    'invalid-feedback': invalid
  }, infoTextControlClass), cssModule);
  var inputClasses = mapToCssModules(classnames(classes, !baseCondition && {
    // we can model here only if stylings
    'form-control-plaintext': normalizedOnlyCondition,
    'form-control': passwordOnlyCondition,
    'input-password': passwordOnlyCondition,
    'focus--mouse': passwordOnlyCondition || normalizedOnlyCondition
  }), cssModule);
  var activeClass = mapToCssModules(classnames({
    active: isFocused || placeholder || value
  }), cssModule);
  return {
    wrapperClass: wrapperClass,
    inputClasses: inputClasses,
    activeClass: activeClass,
    infoTextClass: infoTextClass
  };
}

var deprecated = Util.deprecated,
    warnOnce = Util.warnOnce;
var propTypes$s = {
  children: PropTypes.node,
  type: PropTypes.string,
  size: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  infoText: PropTypes.string,
  normalized: PropTypes.bool,
  bsSize: PropTypes.string,
  state: deprecated(PropTypes.string, 'Please use the props "valid" and "invalid" to indicate the state.'),
  valid: PropTypes.bool,
  invalid: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  static: deprecated(PropTypes.bool, 'Please use the prop "plaintext"'),
  plaintext: PropTypes.bool,
  addon: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object
};
var defaultProps$q = {
  type: 'text'
};

var Input = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Input, _React$Component);

  function Input() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocused: false,
      hidden: true,
      icon: true
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFocusLabel", function () {
      _this.setState({
        isFocused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleBlurLabel", function (e) {
      if (e.target.value === '') {
        _this.setState({
          isFocused: !_this.state.isFocused
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleShow", function () {
      _this.setState({
        hidden: !_this.state.hidden,
        icon: !_this.state.icon
      });
    });

    return _this;
  }

  var _proto = Input.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        type = _this$props.type,
        state = _this$props.state,
        tag = _this$props.tag,
        addon = _this$props.addon,
        staticInput = _this$props.static,
        plaintext = _this$props.plaintext,
        innerRef = _this$props.innerRef,
        label = _this$props.label,
        infoText = _this$props.infoText,
        placeholder = _this$props.placeholder,
        normalized = _this$props.normalized,
        value = _this$props.value,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["id", "className", "cssModule", "type", "state", "tag", "addon", "static", "plaintext", "innerRef", "label", "infoText", "placeholder", "normalized", "value"]);

    var _this$props2 = this.props,
        bsSize = _this$props2.bsSize,
        valid = _this$props2.valid,
        invalid = _this$props2.invalid;
    var Tag = getTag({
      tag: tag,
      plaintext: plaintext,
      staticInput: staticInput,
      type: type
    });
    var formControlClass = getFormControlClass({
      plaintext: plaintext,
      staticInput: staticInput,
      type: type,
      addon: addon
    }, cssModule);
    var infoTextControlClass = getInfoTextControlClass({
      valid: valid,
      invalid: invalid
    }, cssModule);

    if (state && valid == null && invalid == null) {
      invalid = state === 'danger';
      valid = state === 'success';
    }

    if (attributes.size && !isNumber(attributes.size)) {
      warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
      bsSize = attributes.size;
      delete attributes.size;
    }

    if (Tag === 'input' || typeof tag !== 'string') {
      attributes.type = type;
    }

    if (attributes.children && !(plaintext || staticInput || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
      warnOnce("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
      delete attributes.children;
    }

    var inputPassword = attributes.type === 'password'; // Styling

    var _getClasses = getClasses(className, {
      valid: valid,
      invalid: invalid,
      bsSize: bsSize,
      placeholder: placeholder,
      value: value,
      label: label,
      infoText: infoText,
      normalized: normalized,
      inputPassword: inputPassword,
      formControlClass: formControlClass,
      infoTextControlClass: infoTextControlClass,
      isFocused: this.state.isFocused
    }, cssModule),
        activeClass = _getClasses.activeClass,
        infoTextClass = _getClasses.infoTextClass,
        inputClasses = _getClasses.inputClasses,
        wrapperClass = _getClasses.wrapperClass; // set of attributes always shared by the Input components


    var sharedAttributes = {
      id: id,
      onFocus: this.toggleFocusLabel,
      onBlur: this.toggleBlurLabel,
      value: value,
      ref: innerRef
    }; // set of attributes always shared by the wrapper component

    var containerProps = {
      id: id,
      activeClass: activeClass,
      label: label,
      infoTextClass: infoTextClass,
      infoText: infoText,
      wrapperClass: wrapperClass
    };

    if (placeholder) {
      return /*#__PURE__*/React__default.createElement(InputContainer, containerProps, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, sharedAttributes, {
        className: inputClasses,
        placeholder: placeholder
      })));
    }

    if (inputPassword) {
      return /*#__PURE__*/React__default.createElement(InputContainer, containerProps, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, sharedAttributes, {
        type: this.state.hidden ? 'password' : 'text',
        className: inputClasses,
        placeholder: placeholder
      })), /*#__PURE__*/React__default.createElement("span", {
        className: "password-icon",
        "aria-hidden": "true"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        size: "sm",
        icon: "it-password-" + (this.state.icon ? 'visible' : 'invisible'),
        className: "password-icon-visible",
        onClick: this.toggleShow
      })));
    }

    if (normalized) {
      return /*#__PURE__*/React__default.createElement(InputContainer, containerProps, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, sharedAttributes, {
        className: inputClasses,
        readOnly: true
      })));
    }

    if (label || infoText) {
      return /*#__PURE__*/React__default.createElement(InputContainer, containerProps, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, sharedAttributes, {
        className: inputClasses
      })));
    }

    return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      className: inputClasses
    }, sharedAttributes));
  };

  return Input;
}(React__default.Component);

Input.propTypes = propTypes$s;
Input.defaultProps = defaultProps$q;
var propTypes$t = {
  /** Utilizzarlo in caso di utilizzo di componenti personalizzati */
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  /** Da utilizzare in caso di titolo principale della lista. Passare una componente React da mostrare come titolo */
  header: PropTypes.node,

  /** Classi aggiuntive da usare per il componente lista del LinkList */
  className: PropTypes.string,

  /** Classi aggiuntive da usare per il componente wrapper del LinkList */
  wrapperClassName: PropTypes.string,

  /** Quando è abilitato gestisce una lista in cui ciascun elemento è composto da più componenti/elementi. */
  multiline: PropTypes.bool,
  sublist: PropTypes.bool,
  avatar: PropTypes.bool
};
var defaultProps$r = {
  tag: 'div'
};

var LinkList = function LinkList(props) {
  var className = props.className,
      wrapperClassName = props.wrapperClassName,
      Tag = props.tag,
      multiline = props.multiline,
      header = props.header,
      sublist = props.sublist,
      avatar = props.avatar,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "wrapperClassName", "tag", "multiline", "header", "sublist", "avatar"]);

  var wrapperClasses = classnames(multiline ? 'multiline' : false, 'link-list-wrapper', wrapperClassName);
  var classes = classnames(className, sublist ? 'link-sublist' : 'link-list', avatar && 'avatar-group');

  if (sublist) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, header, /*#__PURE__*/React__default.createElement("ul", _extends({}, attributes, {
      className: classes
    })));
  }

  return /*#__PURE__*/React__default.createElement(Tag, {
    className: wrapperClasses
  }, header, /*#__PURE__*/React__default.createElement("ul", _extends({}, attributes, {
    className: classes
  })));
};

LinkList.propTypes = propTypes$t;
LinkList.defaultProps = defaultProps$r;
var propTypes$u = {
  /** Indica se l'elemento è attivo o no */
  active: PropTypes.bool,

  /** Indica se l'elemento è disabilitato o no */
  disabled: PropTypes.bool,

  /** Indica se l'elemento è un titolo. */
  header: PropTypes.bool,

  /** Indica se l'elemento è un divisore */
  divider: PropTypes.bool,

  /** Utilizzarlo in caso di utilizzo di componenti personalizzati */
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  /** Classi aggiuntive da usare per il componente LinkListItem */
  className: PropTypes.any,

  /** Indica il link a cui l'elemento deve puntare. */
  href: PropTypes.string,

  /** Indica la taglia/grandezza dell'elemento */
  size: PropTypes.string
};
var defaultProps$s = {
  tag: 'a'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var LinkListItem = function LinkListItem(_ref) {
  var className = _ref.className,
      active = _ref.active,
      disabled = _ref.disabled,
      header = _ref.header,
      divider = _ref.divider,
      href = _ref.href,
      size = _ref.size,
      Tag = _ref.tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["className", "active", "disabled", "header", "divider", "href", "size", "tag"]);

  var classes = classnames(className, {
    active: active,
    disabled: disabled,
    header: header,
    divider: divider,
    size: size
  }, 'list-item'); // Prevent click event when disabled.

  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }

  if (header) {
    Tag = 'h3';
  } else if (divider) {
    Tag = 'span';
  }

  if (header && href) {
    return /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement(Tag, null, /*#__PURE__*/React__default.createElement("a", _extends({
      href: href || '#'
    }, attributes, {
      className: classes
    }))));
  }

  attributes.href = href;
  return /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: classes
  })));
};

LinkListItem.propTypes = propTypes$u;
LinkListItem.defaultProps = defaultProps$s;
var propTypes$v = {
  /** Renderizza i componenti NavItem al suo interno come tab. */
  tabs: PropTypes.bool,

  /** Renderizza i componenti NavItem al suo interno come pills. */
  pills: PropTypes.bool,

  /** Renderizza i componenti NavItem al suo interno come tab. */
  card: PropTypes.bool,

  /** Se abilitato tutti i NavItem all'interno avranno la stessa larghezza */
  justified: PropTypes.bool,

  /** Se abilitato i NavItem all'intero occuperanno tutto lo spazio disponibile  */
  fill: PropTypes.bool,

  /** Da utilizzare per rendere il componente Nav verticale. Viene abilitato automaticamente in versione mobile. Valori possibili sono `true`, `false` o `"xs"` */
  vertical: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /** Da utilizzare per cambiare l'allineamento all'interno della Nav. Valori possibili sono `"center"` o `"end"` per posizionare il contenuto a centro o sulla destra. */
  horizontal: PropTypes.string,

  /** Se utilizzata all'interno di una navbar, impostarlo su `true`. In caso di Header Nav, impostarlo a `true` insieme a inHeader. */
  navbar: PropTypes.bool,

  /** Utilizzarlo in caso di utilizzo di componenti personalizzati */
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};
var defaultProps$t = {
  tag: 'ul',
  vertical: false
};

var Nav = function Nav(_ref) {
  var attributes = _extends({}, _ref);

  return /*#__PURE__*/React__default.createElement(Nav$1, attributes);
};

Nav.propTypes = propTypes$v;
Nav.defaultProps = defaultProps$t;
var propTypes$w = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  'aria-label': PropTypes.string
};
var defaultProps$u = {
  tag: 'nav',
  'aria-label': 'pagination'
};

var Pager = function Pager(props) {
  var children = props.children,
      className = props.className,
      Tag = props.tag,
      label = props['aria-label'];
  var classes = classnames(className, 'pagination-wrapper');
  return /*#__PURE__*/React__default.createElement(Tag, {
    className: classes,
    "aria-label": label
  }, children);
};

Pager.propTypes = propTypes$w;
Pager.defaultProps = defaultProps$u;
var propTypes$x = {
  className: PropTypes.string,
  size: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};
var defaultProps$v = {
  tag: 'ul'
};

var PagerList = function PagerList(props) {
  var _classNames;

  var className = props.className,
      size = props.size,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "size", "tag"]);

  var listClasses = classnames(className, 'pagination', (_classNames = {}, _classNames["pagination-" + size] = !!size, _classNames));
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: listClasses
  }));
};

PagerList.propTypes = propTypes$x;
PagerList.defaultProps = defaultProps$v;

var noop = function noop() {};

var propTypes$y = {
  /** La lista di id per ciascun elemento intero del Rating. La lista deve essere ordinata dal rating 1 al rating 5.  */
  inputs: PropTypes.arrayOf(PropTypes.string).isRequired,

  /** Il campo "label" è impostato di default su "Valuta ${n} stelle su 5", ma può essere personalizzato con questa funzione che riceve il numero input come argomento `function (n: number) => string`. */
  labelTemplate: PropTypes.func,

  /** Da utilizzare in caso legenda principale del Rating. Passare una componente React da mostrare come legenda (all'interno del tag `<legend>`). It is possible also to show the legend of screen readers only */
  legend: PropTypes.oneOf([PropTypes.node, PropTypes.string, PropTypes.shape({
    content: PropTypes.string,
    srOnly: PropTypes.bool
  })]),

  /** Mostra la leggenda solo ai dispositivi screen reader */

  /** Parametro name da dare all'input */
  name: PropTypes.string,

  /** Classi aggiuntive da usare per il componente wrapper del Rating */
  wrapperClassName: PropTypes.string,

  /** Classi aggiuntive da usare per ciascun elemento all'interno del componente Rating */
  className: PropTypes.string,

  /** Callback chiamata ad ogni cambio di valore di rating. Il nuovo valore ed il name verranno passati: `function (n, name) => void` */
  onChangeRating: PropTypes.func,

  /** Rende il componente read-only */
  readOnly: PropTypes.bool,

  /** Il valore corrente del componente */
  value: PropTypes.number
};
var defaultProps$w = {
  onChangeRating: function onChangeRating(value, name) {},
  labelTemplate: function labelTemplate(value) {
    return "Valuta " + value + " stelle su 5";
  }
};

var Rating = function Rating(props) {
  var className = props.className,
      inputs = props.inputs,
      labelTemplate = props.labelTemplate,
      legend = props.legend,
      name = props.name,
      onChangeRating = props.onChangeRating,
      readOnly = props.readOnly,
      value = props.value,
      wrapperClassName = props.wrapperClassName,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "inputs", "labelTemplate", "legend", "name", "onChangeRating", "readOnly", "value", "wrapperClassName"]); // Input data
  // On the DOM we have to go from 5 to 1


  var safeInputs = (inputs || []).reverse(); // Fields

  var labelFn = labelTemplate;
  var onChange = readOnly ? onChangeRating : noop;
  var wrapperClasses = classnames(wrapperClassName, {
    'rating-read-only': readOnly,
    'rating-label': legend
  });
  var fieldClasses = classnames(className);
  var extraFieldAttrs = readOnly ? {
    ariaHidden: 'true'
  } : {}; // Legend

  var isLegendString = typeof legend === 'string';
  var isLegendObject = legend != null && typeof legend === 'object' && typeof legend.content === 'string';
  var legendClass = classnames({
    'sr-only': isLegendObject && legend.srOnly
  });
  var legendText = isLegendObject ? legend.content : legend;
  var legendContent = isLegendObject || isLegendString ? /*#__PURE__*/React__default.createElement("span", {
    className: legendClass
  }, legendText) : legend;
  return /*#__PURE__*/React__default.createElement(FormGroup, _extends({
    cssModule: {
      'form-group': 'rating'
    },
    tag: "fieldset",
    className: wrapperClasses
  }, attributes), legend && /*#__PURE__*/React__default.createElement("legend", null, legendContent), safeInputs.map(function (id, i) {
    var currentValue = 5 - i;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Input, _extends({
      type: "radio",
      id: id,
      name: name,
      value: currentValue,
      cssModule: {
        'form-control': ' '
      },
      className: fieldClasses,
      onClick: function onClick() {
        return onChange(currentValue, name);
      },
      checked: value === currentValue,
      disabled: readOnly
    }, extraFieldAttrs)), /*#__PURE__*/React__default.createElement(Label, {
      className: "full",
      for: id
    }, /*#__PURE__*/React__default.createElement(Icon, {
      icon: "it-star-full",
      size: "sm"
    }), /*#__PURE__*/React__default.createElement("span", {
      className: "sr-only"
    }, labelFn(5 - i))));
  }));
};

Rating.propTypes = propTypes$y;
Rating.defaultProps = defaultProps$w;

var PasswordInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PasswordInput, _Component);

  function PasswordInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      showPassword: false
    });

    _defineProperty(_assertThisInitialized(_this), "onPasswordToggle", function () {
      _this.setState(function (prevState) {
        return {
          showPassword: !prevState.showPassword
        };
      });
    });

    return _this;
  }

  var _proto = PasswordInput.prototype;

  _proto.render = function render() {
    var showPassword = this.state.showPassword;

    var _this$props = this.props,
        type = _this$props.type,
        rest = _objectWithoutPropertiesLoose(_this$props, ["type"]);

    var classNames = ['btn-eye', showPassword ? 'eye-off' : 'eye-on'].join(' ');
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      className: classNames,
      onClick: this.onPasswordToggle
    }), /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, {
      type: showPassword ? 'text' : type
    })));
  };

  return PasswordInput;
}(Component);

_defineProperty(PasswordInput, "defaultProps", {
  type: 'password'
});

PasswordInput.propTypes = _extends({}, Input.propTypes);
var defaultSteps = [{
  score: 0,
  label: 'inserisci almeno 8 caratteri e una lettera maiuscola',
  className: 'danger'
}, {
  score: 1,
  label: 'password troppo debole',
  className: 'danger'
}, {
  score: 25,
  label: 'password debole',
  className: 'danger'
}, {
  score: 50,
  label: 'password sicura',
  className: 'warning'
}, {
  score: 75,
  label: 'password molto sicura',
  className: 'success'
}];

var PasswordMeter = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PasswordMeter, _Component);

  function PasswordMeter() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = PasswordMeter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        steps = _this$props.steps,
        score = _this$props.score;
    var currentStep = steps.filter(function (step) {
      return step.score <= score;
    }).reduce(function (acc, current) {
      return acc.score > current.score ? acc : current;
    });
    var label = currentStep.label,
        className = currentStep.className;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "psw-wrapper"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "psw-text text-" + className + " " + className
    }, label), /*#__PURE__*/React__default.createElement("div", {
      className: "progress rounded-0 position-relative psw-meter"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row position-absolute w-100 m-0"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "col-3 border-left border-right border-white"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "col-3 border-left border-right border-white"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "col-3 border-left border-right border-white"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "col-3 border-left border-right border-white"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "progress-bar bg-" + className + " " + className,
      style: {
        width: score + "%"
      }
    })));
  };

  return PasswordMeter;
}(Component);

_defineProperty(PasswordMeter, "defaultProps", {
  score: 0,
  steps: defaultSteps
});

PasswordMeter.propTypes = {
  score: PropTypes.number,
  steps: PropTypes.arrayOf(PropTypes.shape({
    score: PropTypes.number,
    label: PropTypes.string,
    className: PropTypes.string
  }))
};
var propTypes$z = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
};
var defaultProps$x = {
  tag: 'div'
};

var Skiplink = function Skiplink(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag"]);

  var classes = classnames(className, 'skiplinks');
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, attributes));
};

Skiplink.propTypes = propTypes$z;
Skiplink.defaultProps = defaultProps$x;
var propTypes$A = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
};
var defaultProps$y = {
  tag: 'a'
};

var SkiplinkItem = function SkiplinkItem(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag"]);

  var classes = classnames(className, 'sr-only', 'sr-only-focusable');
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, attributes));
};

SkiplinkItem.propTypes = propTypes$A;
SkiplinkItem.defaultProps = defaultProps$y;

var Toggle = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Toggle, _Component);

  function Toggle() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Toggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        rest = _objectWithoutPropertiesLoose(_this$props, ["label"]);

    return /*#__PURE__*/React__default.createElement("div", {
      className: "toggles"
    }, /*#__PURE__*/React__default.createElement(Label, {
      check: true
    }, label, /*#__PURE__*/React__default.createElement(Input$1, _extends({
      type: "checkbox"
    }, rest)), /*#__PURE__*/React__default.createElement("span", {
      className: "lever"
    })));
  };

  return Toggle;
}(Component);

Toggle.propTypes = _extends({
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}, Input$1.propTypes);
var propTypes$B = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  secondary: PropTypes.bool,
  left: PropTypes.bool,
  right: PropTypes.bool,
  dark: PropTypes.bool
};
var defaultProps$z = {
  tag: 'div'
};

var Sidebar = function Sidebar(props) {
  var className = props.className,
      Tag = props.tag,
      secondary = props.secondary,
      left = props.left,
      right = props.right,
      dark = props.dark,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag", "secondary", "left", "right", "dark"]);

  var wrapperClasses = classnames(className, left ? 'it-line-left-side' : false, right ? 'it-line-right-side' : false, dark ? 'theme-dark' : false, 'sidebar-wrapper');
  var wrapperClassesLinkList = classnames(secondary ? 'linklist-secondary' : false, 'sidebar-linklist-wrapper');

  if (secondary) {
    return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      className: wrapperClassesLinkList
    }));
  }

  return /*#__PURE__*/React__default.createElement(Tag, {
    className: wrapperClasses
  }, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: wrapperClassesLinkList
  })));
};

Sidebar.propTypes = propTypes$B;
Sidebar.defaultProps = defaultProps$z;
var propTypes$C = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  value: PropTypes.number,
  label: PropTypes.string,
  indeterminate: PropTypes.bool,
  color: PropTypes.string
};
var defaultProps$A = {
  tag: 'div',
  role: 'progressbar',
  indeterminate: false
};

var Progress = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Progress, _React$Component);

  function Progress() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Progress.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        Tag = _this$props.tag,
        value = _this$props.value,
        label = _this$props.label,
        indeterminate = _this$props.indeterminate,
        color = _this$props.color,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["className", "tag", "value", "label", "indeterminate", "color"]);

    var wrapperClasses = classnames('progress-bar-wrapper');
    var secondaryWrapperClasses = classnames(className, indeterminate ? 'progress-indeterminate' : false, color ? 'progress-color' : false, 'progress');
    var classes = classnames(className, 'progress-bar', color ? "bg-" + this.props.color : false);

    if (label && value) {
      return /*#__PURE__*/React__default.createElement(Tag, {
        className: wrapperClasses
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "progress-bar-label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "sr-only"
      }, this.props.label), this.props.value + '%'), /*#__PURE__*/React__default.createElement(Tag, {
        className: secondaryWrapperClasses
      }, /*#__PURE__*/React__default.createElement("div", _extends({}, attributes, {
        className: classes,
        role: "progressbar",
        style: {
          width: this.props.value + '%'
        },
        "aria-valuenow": this.props.value,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }))));
    }

    return /*#__PURE__*/React__default.createElement(Tag, {
      className: secondaryWrapperClasses
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "progress-bar-label"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "sr-only"
    }, this.props.label)), /*#__PURE__*/React__default.createElement("div", _extends({}, attributes, {
      className: classes,
      role: "progressbar",
      style: {
        width: this.props.value + '%'
      },
      "aria-valuenow": this.props.value,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    })));
  };

  return Progress;
}(React__default.Component);

Progress.propTypes = propTypes$C;
Progress.defaultProps = defaultProps$A;
var propTypes$D = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  active: PropTypes.bool,
  small: PropTypes.bool,
  double: PropTypes.bool
};
var defaultProps$B = {
  tag: 'span',
  active: false,
  small: false,
  double: false
};

var Spinner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Spinner, _React$Component);

  function Spinner() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Spinner.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        Tag = _this$props.tag,
        active = _this$props.active,
        small = _this$props.small,
        double = _this$props.double,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["className", "tag", "active", "small", "double"]);

    var wrapperClasses = classnames(active ? 'progress-spinner-active' : false, small ? 'size-sm' : false, double ? 'progress-spinner-double' : false, 'progress-spinner');
    var innerClasses = classnames('progress-spinner-inner');
    var classes = classnames(className, 'sr-only');

    if (double) {
      return /*#__PURE__*/React__default.createElement(Tag, {
        className: wrapperClasses
      }, /*#__PURE__*/React__default.createElement("div", {
        className: innerClasses
      }), /*#__PURE__*/React__default.createElement("div", {
        className: innerClasses
      }), /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
        className: classes
      }), "Caricamento..."));
    }

    return /*#__PURE__*/React__default.createElement(Tag, {
      className: wrapperClasses
    }, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      className: classes
    }), "Caricamento..."));
  };

  return Spinner;
}(React__default.Component);

Spinner.propTypes = propTypes$D;
Spinner.defaultProps = defaultProps$B;

var propTypes$E = _extends({}, Card$1.propTypes, {
  teaser: PropTypes.bool,
  spacing: PropTypes.bool,
  noWrapper: PropTypes.bool,
  wrapperClassName: PropTypes.string
});

var defaultProps$C = _extends({}, Card$1.defaultProps, {
  noWrapper: false
});

var Card = function Card(_ref) {
  var teaser = _ref.teaser,
      spacing = _ref.spacing,
      noWrapper = _ref.noWrapper,
      wrapperClassName = _ref.wrapperClassName,
      attributes = _objectWithoutPropertiesLoose(_ref, ["teaser", "spacing", "noWrapper", "wrapperClassName"]);

  var wrapperClasses = classnames('card-wrapper', wrapperClassName, {
    'card-space': spacing,
    'card-teaser-wrapper': teaser
  });
  var cardClasses = classnames(attributes.className, {
    'card-teaser': teaser
  });

  if (noWrapper) {
    return /*#__PURE__*/React__default.createElement(Card$1, _extends({}, attributes, {
      className: cardClasses
    }));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/React__default.createElement(Card$1, _extends({}, attributes, {
    className: cardClasses
  })));
};

Card.propTypes = propTypes$E;
Card.defaultProps = defaultProps$C;
var propTypes$F = {
  iconName: PropTypes.string,
  date: PropTypes.string,
  href: PropTypes.string
};

var CardCategory = function CardCategory(props) {
  var iconName = props.iconName,
      date = props.date,
      href = props.href,
      attributes = _objectWithoutPropertiesLoose(props, ["iconName", "date", "href"]);

  var children = attributes.children,
      rest = _objectWithoutPropertiesLoose(attributes, ["children"]);

  var classes = classnames({
    'category-top': date || ' ',
    'categoryicon-top': iconName
  }); // Simple category link

  var categoryLink = !iconName && /*#__PURE__*/React__default.createElement("a", {
    href: href,
    className: "category"
  }, children);
  var categoryDate = date && /*#__PURE__*/React__default.createElement("span", {
    className: "data"
  }, date); // Category with icon

  var categoryText = iconName && /*#__PURE__*/React__default.createElement("span", {
    className: "text"
  }, children);
  var categoryIcon = iconName && /*#__PURE__*/React__default.createElement(Icon, {
    icon: iconName
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, rest), categoryLink, categoryIcon, categoryText, categoryDate);
};

CardCategory.propTypes = propTypes$F;
var propTypes$G = {
  tag: PropTypes.string,
  className: PropTypes.string
};
var defaultProps$D = {
  tag: 'a'
};

var CardTag = function CardTag(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag"]);

  var classes = classnames(className, 'card-tag');
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, attributes));
};

CardTag.propTypes = propTypes$G;
CardTag.defaultProps = defaultProps$D;
var propTypes$H = {
  children: PropTypes.node,
  date: PropTypes.string
};

var CardTagsHeader = function CardTagsHeader(props) {
  var date = props.date,
      children = props.children,
      attributes = _objectWithoutPropertiesLoose(props, ["date", "children"]);

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "head-tags"
  }, attributes), children, date && /*#__PURE__*/React__default.createElement("span", {
    className: "data"
  }, date));
};

CardTagsHeader.propTypes = propTypes$H;
var propTypes$I = {
  className: PropTypes.string
};

var CardSignature = function CardSignature(props) {
  var className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, ["className"]);

  var classes = classnames(className, 'card-signature');
  return /*#__PURE__*/React__default.createElement("span", _extends({
    className: classes
  }, attributes));
};

CardSignature.propTypes = propTypes$I;
var propTypes$J = {
  className: PropTypes.string
};

var CardFooterCTA = function CardFooterCTA(props) {
  var className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, ["className"]);

  var classes = classnames(className, 'it-card-footer');
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, attributes));
};

CardFooterCTA.propTypes = propTypes$J;
var propTypes$K = {
  className: PropTypes.string,
  iconName: PropTypes.string,
  href: PropTypes.string,
  text: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.shape({
    $$typeof: PropTypes.symbol,
    render: PropTypes.func
  }), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.shape({
    $$typeof: PropTypes.symbol,
    render: PropTypes.func
  })]))])
};
var defaultProps$E = {
  tag: 'a',
  iconName: 'it-arrow-right'
};

var CardReadMore = function CardReadMore(props) {
  var className = props.className,
      text = props.text,
      iconName = props.iconName,
      Tag = props.tag,
      href = props.href,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "text", "iconName", "tag", "href"]);

  var classes = classnames(className, 'read-more');
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes,
    href: href
  }, attributes), /*#__PURE__*/React__default.createElement("span", {
    className: "text"
  }, text), iconName && /*#__PURE__*/React__default.createElement(Icon, {
    icon: iconName
  }));
};

CardReadMore.propTypes = propTypes$K;
CardReadMore.defaultProps = defaultProps$E;
var propTypes$L = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
};
var defaultProps$F = {
  tag: 'nav'
};

var BottomNav = function BottomNav(props) {
  var Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["tag"]);

  var wrapperClasses = classnames('bottom-nav');
  return /*#__PURE__*/React__default.createElement(Tag, {
    className: wrapperClasses
  }, /*#__PURE__*/React__default.createElement("ul", attributes));
};

BottomNav.propTypes = propTypes$L;
BottomNav.defaultProps = defaultProps$F;
var propTypes$M = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  active: PropTypes.bool,
  link: PropTypes.string,
  label: PropTypes.string,
  iconName: PropTypes.string,
  srText: PropTypes.string,
  alert: PropTypes.bool,
  badge: PropTypes.bool
};
var defaultProps$G = {
  tag: 'a',
  link: '#',
  iconName: 'it-comment',
  srText: false
};

var BottomNavItem = function BottomNavItem(_ref) {
  var active = _ref.active,
      badge = _ref.badge,
      alert = _ref.alert,
      link = _ref.link,
      srText = _ref.srText,
      iconName = _ref.iconName,
      label = _ref.label,
      Tag = _ref.tag,
      attributes = _objectWithoutPropertiesLoose(_ref, ["active", "badge", "alert", "link", "srText", "iconName", "label", "tag"]);

  var activeClass = classnames(active ? 'active' : false);
  var badgeWrapper = badge ? /*#__PURE__*/React__default.createElement("div", {
    className: "badge-wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bottom-nav-badge"
  }, badge)) : false;
  var alertWrapper = alert ? /*#__PURE__*/React__default.createElement("div", {
    className: "badge-wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bottom-nav-alert"
  })) : false;
  return /*#__PURE__*/React__default.createElement("li", attributes, /*#__PURE__*/React__default.createElement(Tag, {
    href: link,
    className: activeClass
  }, badgeWrapper, alertWrapper, /*#__PURE__*/React__default.createElement(Icon, {
    icon: iconName
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "bottom-nav-label"
  }, label, /*#__PURE__*/React__default.createElement("span", {
    className: "sr-only"
  }, srText))));
};

BottomNavItem.propTypes = propTypes$M;
BottomNavItem.defaultProps = defaultProps$G;
var propTypes$N = {
  children: PropTypes.element,
  fixedWidth: PropTypes.bool,
  isSmall: PropTypes.bool,
  isVertical: PropTypes.bool,
  noZoomOnHover: PropTypes.bool,
  overlayOnHover: PropTypes.oneOf(['black', 'primary']),
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  rowItems: PropTypes.oneOf([2, 3, 4, 5])
};
var defaultProps$H = {
  fixedWidth: false,
  isSmall: false,
  isVertical: false,
  noZoomOnHover: false
};

var ThumbNav = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ThumbNav, _React$Component);

  function ThumbNav() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ThumbNav.prototype;

  _proto.render = function render() {
    var _classNames;

    var classes = classnames('thumb-nav', (_classNames = {
      'thumb-nav-fixed': this.props.fixedWidth,
      'thumb-nav-small': this.props.isSmall,
      'thumb-nav-vertical': this.props.isVertical,
      'thumb-nav-nozoom': this.props.noZoomOnHover
    }, _classNames["thumb-nav-" + this.props.overlayOnHover] = this.props.overlayOnHover, _classNames["thumb-nav-" + this.props.position] = this.props.position, _classNames['thumb-nav-auto'] = this.props.rowItems != null, _classNames["thumb-nav-auto-" + this.props.rowItems] = typeof this.props.rowItems === 'number', _classNames));
    return /*#__PURE__*/React__default.createElement("ul", {
      className: classes
    }, this.props.children);
  };

  return ThumbNav;
}(React__default.Component);

ThumbNav.propTypes = propTypes$N;
ThumbNav.defaultProps = defaultProps$H;
var resizer = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMjQwIDE2MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQwIDE2MDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgoJPHJlY3Qgd2lkdGg9IjI0MCIgaGVpZ2h0PSIxNjAiLz4KPC9zdmc+';
var propTypes$O = {
  active: PropTypes.bool,
  targetUrl: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  actionDescription: PropTypes.string
};
var defaultProps$I = {
  active: false
};

var ThumbNavItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ThumbNavItem, _React$Component);

  function ThumbNavItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ThumbNavItem.prototype;

  _proto.render = function render() {
    var classes = classnames({
      active: this.props.active
    });
    return /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("img", {
      src: resizer,
      className: "thumb-nav-resizer",
      "aria-hidden": "true"
    }), /*#__PURE__*/React__default.createElement("a", {
      href: this.props.targetUrl,
      className: classes
    }, /*#__PURE__*/React__default.createElement("img", {
      src: this.props.imageUrl,
      alt: this.props.actionDescription
    })));
  };

  return ThumbNavItem;
}(React__default.Component);

ThumbNavItem.propTypes = propTypes$O;
ThumbNavItem.defaultProps = defaultProps$I;
var propTypes$P = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
};
var defaultProps$J = {
  tag: 'div'
};

function CookieBar(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag"]);

  var wrapperClasses = classnames('cookiebar show', className);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: wrapperClasses
  }));
}

CookieBar.propTypes = propTypes$P;
CookieBar.defaultProps = defaultProps$J;
var propTypes$Q = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
};
var defaultProps$K = {
  tag: 'div'
};

var CookieBarButtons = function CookieBarButtons(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag"]);

  var buttonClasses = classnames(className, 'cookiebar-buttons');
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: buttonClasses
  }, attributes));
};

CookieBarButtons.propTypes = propTypes$Q;
CookieBarButtons.defaultProps = defaultProps$K;
var propTypes$R = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
};
var defaultProps$L = {
  tag: 'button'
};

var CookieBarButton = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CookieBarButton, _React$Component);

  function CookieBarButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CookieBarButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Tag = _this$props.tag,
        className = _this$props.className,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["tag", "className"]);

    var activeClass = classnames(className, 'cookiebar-btn');
    return /*#__PURE__*/React__default.createElement(Tag, _extends({
      href: true,
      className: activeClass
    }, attributes));
  };

  return CookieBarButton;
}(React__default.Component);

CookieBarButton.propTypes = propTypes$R;
CookieBarButton.defaultProps = defaultProps$L;
var propTypes$S = {
  /** Utilizzarlo in caso di utilizzo di componenti personalizzati */
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  /** Classi aggiuntive da usare per il componente Chip */
  className: PropTypes.string,

  /** Impostarlo su `true` per centrare la label all'interno */
  simple: PropTypes.bool,

  /** Impostarlo su `true` per una versione più grande del componente Chip. */
  large: PropTypes.bool,

  /** Impostarlo su `true` per renderizzare il componente Chip come disabilitato */
  disabled: PropTypes.bool,
  color: PropTypes.string
};
var defaultProps$M = {
  tag: 'div',
  simple: false,
  large: false,
  disabled: false,
  color: ''
};

var Chip = function Chip(props) {
  var _classNames;

  var className = props.className,
      color = props.color,
      Tag = props.tag,
      simple = props.simple,
      large = props.large,
      disabled = props.disabled,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "color", "tag", "simple", "large", "disabled"]);

  var classes = classnames('chip', className, (_classNames = {
    'chip-simple': simple,
    'chip-lg': large,
    'chip-disabled': disabled
  }, _classNames["chip-" + color] = color, _classNames));
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    className: classes
  }, attributes));
};

Chip.propTypes = propTypes$S;
Chip.defaultProps = defaultProps$M;
var propTypes$T = {
  /** Utilizzarlo in caso di utilizzo di componenti personalizzati */
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  /** Classi aggiuntive da usare per il componente ChipLabel */
  className: PropTypes.string
};
var defaultProps$N = {
  tag: 'span'
};

var ChipLabel = function ChipLabel(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "tag"]);

  var classes = classnames(className, 'chip-label');
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

ChipLabel.propTypes = propTypes$T;
ChipLabel.defaultProps = defaultProps$N;

var ToolkitFontLoader = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ToolkitFontLoader, _Component);

  function ToolkitFontLoader() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ToolkitFontLoader.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (typeof window !== 'undefined') {
      var WebFont = require('webfontloader');

      WebFont.load({
        custom: {
          families: ['Titillium Web:300,400,600,700:latin-ext', 'Lora:400,700:latin-ext', 'Roboto Mono:400,700:latin-ext']
        }
      });
    }
  };

  _proto.render = function render() {
    return null;
  };

  return ToolkitFontLoader;
}(Component);

var propTypes$U = {
  icon: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string
};

var Dimmer = function Dimmer(props) {
  var _classNames;

  var icon = props.icon,
      color = props.color,
      className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, ["icon", "color", "className"]);

  var children = attributes.children,
      rest = _objectWithoutPropertiesLoose(attributes, ["children"]);

  var classes = classnames('dimmer', className, (_classNames = {}, _classNames["dimmer-" + color] = color, _classNames));
  var innerClasses = classnames('dimmer-inner', className);
  var dimmerIcon = icon && /*#__PURE__*/React__default.createElement("div", {
    className: "dimmer-icon"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    icon: icon
  }));
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, rest, {
    style: {
      display: 'flex'
    }
  }), /*#__PURE__*/React__default.createElement("div", _extends({
    className: innerClasses
  }, rest), dimmerIcon, children));
};

Dimmer.propTypes = propTypes$U;
var propTypes$V = {
  color: PropTypes.string,
  dark: PropTypes.string,
  single: PropTypes.string,
  className: PropTypes.string
};
var defaultProps$O = {
  single: false,
  dark: false
};

var DimmerButtons = function DimmerButtons(props) {
  var color = props.color,
      dark = props.dark,
      className = props.className,
      single = props.single,
      attributes = _objectWithoutPropertiesLoose(props, ["color", "dark", "className", "single"]);

  var children = attributes.children,
      rest = _objectWithoutPropertiesLoose(attributes, ["children"]);

  var classes = classnames('dimmer-buttons', className, {
    'single-button': single,
    'bg-dark': dark
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, rest), children);
};

DimmerButtons.propTypes = propTypes$V;
DimmerButtons.defaultProps = defaultProps$O;

var Timeline = function Timeline(props) {
  var className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, ["className"]);

  var children = attributes.children,
      rest = _objectWithoutPropertiesLoose(attributes, ["children"]);

  var timelineWrapper = classnames(className, 'it-timeline-wrapper');
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: timelineWrapper
  }, rest), children);
};

Timeline.propTypes = {
  className: PropTypes.string
};

var TimelinePin = function TimelinePin(props) {
  var icon = props.icon,
      label = props.label,
      past = props.past,
      now = props.now,
      nowText = props.nowText,
      className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, ["icon", "label", "past", "now", "nowText", "className"]);

  var children = attributes.children,
      rest = _objectWithoutPropertiesLoose(attributes, ["children"]);

  var classes = classnames('timeline-element', className);
  var innerClasses = classnames('it-pin-wrapper', className, {
    'it-evidence': past,
    'it-now': now
  });
  var pinIcon = /*#__PURE__*/React__default.createElement("div", {
    className: "pin-icon"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    icon: icon
  }));
  var pinLabel = /*#__PURE__*/React__default.createElement("div", {
    className: "pin-text"
  }, /*#__PURE__*/React__default.createElement("span", null, label));
  var pinTextNow = now && /*#__PURE__*/React__default.createElement("span", {
    className: "it-now-label d-none d-lg-flex"
  }, nowText);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes
  }, pinTextNow, /*#__PURE__*/React__default.createElement("div", _extends({
    className: innerClasses
  }, rest), pinIcon, pinLabel), children);
};

TimelinePin.defaultProps = {
  icon: 'it-code-circle',
  label: ' '
};
/**
 * è stato necessario disabilitare il typecheck per un'incompatibilità su storybook in caso di
 * un unico figlio
 */

TimelinePin.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  now: PropTypes.bool,
  nowText: PropTypes.string,
  past: PropTypes.bool
};
var propTypes$W = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  classNames: PropTypes.string,
  children: PropTypes.element
};
var defaultProps$P = {
  tag: 'ul'
};

var StepperHeader = function StepperHeader(props) {
  var Tag = props.tag,
      children = props.children,
      attributes = _objectWithoutPropertiesLoose(props, ["tag", "children"]);

  var wrapperClass = classnames('steppers-header');
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: wrapperClass
  }), children);
};

StepperHeader.propTypes = propTypes$W;
StepperHeader.defaultProps = defaultProps$P;
var propTypes$X = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  children: PropTypes.element,
  dark: PropTypes.string,
  mobile: PropTypes.bool
};
var defaultProps$Q = {
  tag: 'div'
};

var StepperContainer = function StepperContainer(props) {
  var Tag = props.tag,
      children = props.children,
      mobile = props.mobile,
      dark = props.dark,
      attributes = _objectWithoutPropertiesLoose(props, ["tag", "children", "mobile", "dark"]);

  var wrapperClass = classnames('steppers', {
    'bg-dark': dark
  }, {
    'mobile-examples': mobile
  });
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: wrapperClass
  }), children);
};

StepperContainer.propTypes = propTypes$X;
StepperContainer.defaultProps = defaultProps$Q;
var propTypes$Y = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.element,
  icon: PropTypes.string,
  iconName: PropTypes.string,
  stepperNumber: PropTypes.element,
  noLine: PropTypes.bool
};
var defaultProps$R = {};

var StepperHeaderElement = function StepperHeaderElement(props) {
  var Tag = props.tag,
      variant = props.variant,
      icon = props.icon,
      iconName = props.iconName,
      noLine = props.noLine,
      stepperNumber = props.stepperNumber,
      children = props.children,
      attributes = _objectWithoutPropertiesLoose(props, ["tag", "variant", "icon", "iconName", "noLine", "stepperNumber", "children"]);

  var wrapperClasses = classnames(variant, {
    'no-line': noLine
  });
  var iconClass = classnames('icon', 'steppers-success');
  var spanClass = classnames('steppers-number');
  return /*#__PURE__*/React__default.createElement("li", _extends({}, attributes, {
    className: wrapperClasses
  }), iconName && /*#__PURE__*/React__default.createElement(Icon, {
    icon: iconName
  }), stepperNumber && /*#__PURE__*/React__default.createElement("span", {
    className: spanClass
  }, stepperNumber), children, icon && /*#__PURE__*/React__default.createElement(Icon, {
    icon: icon,
    className: iconClass
  }));
};

StepperHeaderElement.propTypes = propTypes$Y;
StepperHeaderElement.defaultProps = defaultProps$R;
var propTypes$Z = {
  muted: PropTypes.string,
  color: PropTypes.string,
  neutral: PropTypes.string,
  image: PropTypes.string,
  className: PropTypes.string
};

var Section = function Section(props) {
  var _classNames;

  var muted = props.muted,
      color = props.color,
      neutral = props.neutral,
      image = props.image,
      className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, ["muted", "color", "neutral", "image", "className"]);

  var children = attributes.children,
      rest = _objectWithoutPropertiesLoose(attributes, ["children"]);

  var classes = classnames('section', className, (_classNames = {
    'section-muted': muted
  }, _classNames["section-" + color] = color, _classNames['section-neutral'] = neutral, _classNames['section-image'] = image, _classNames));
  var innerClasses = classnames('section-content', className);
  var styleClass = {
    backgroundImageClass: {
      'background-image': ["url(" + image + ")"]
    }
  };
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes,
    style: styleClass.backgroundImageClass
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: innerClasses
  }, children));
};

Section.propTypes = propTypes$Z;
export { Accordion, AccordionBody, AccordionHeader, AvatarContainer, AvatarExtraText, AvatarGroupContainer, AvatarIcon, AvatarPresence, AvatarStatus, AvatarWrapper, Badge, BottomNav, BottomNavItem, Button, Callout, CalloutText, CalloutTitle, Card, CardCategory, CardFooterCTA, CardReadMore, CardSignature, CardTag, CardTagsHeader, Chip, ChipLabel, Collapse, CookieBar, CookieBarButton, CookieBarButtons, Dimmer, DimmerButtons, ToolkitFontLoader as FontLoader, Forward, Header, HeaderBrand, HeaderContent, HeaderLinkZone, HeaderRightZone, HeaderSearch, HeaderSocialsZone, HeaderToggler, Headers, Hero, Icon, Input, LinkList, LinkListItem, Nav, Pager, PagerList, PasswordInput, PasswordMeter, Progress, Rating, Section, Sidebar, Skiplink, SkiplinkItem, Spinner, StepperContainer, StepperHeader, StepperHeaderElement, ThumbNav, ThumbNavItem, Timeline, TimelinePin, Toggle, iconsList as icons };